/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * TEX FVE Handler operator console API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Account,
  AccountDetail,
  AccountUpdate,
  AppUser,
  AppUserUpdate,
  AssignSlotRequest,
  AssignSlotResult,
  AuditLogList,
  BackfillPhoneTagsResult,
  BankAccount,
  BankAccountCreate,
  BankImportRequest,
  BankImportSummary,
  BankSwapHistoryEntry,
  BankVariant,
  BankingAuditEntry,
  BankingSource,
  BankingSourceInput,
  BankingSourceUpdate,
  BulkBuybackFveIntentInput,
  BulkBuybackFveIntentResult,
  BulkEventInput,
  BulkHoldRequest,
  BulkHoldResult,
  BulkPhoneTestResult,
  BulkPricePushInput,
  BulkPricePushResult,
  BurnSlotResult,
  BuybackAccount,
  BuybackAccountInput,
  BuybackAccountList,
  BuybackAccountUpdate,
  BuybackCandidateList,
  BuybackCompleteResult,
  BuybackFveIntentInput,
  BuybackGetInInput,
  BuybackMatchList,
  BuybackPhoneTestResult,
  BuybackRefreshTargets,
  CannotListInput,
  CurrentUser,
  DashboardSummary,
  DeleteEvent200,
  DeleteTicketransferTask200,
  Event,
  EventCandidate,
  EventDeletePreview,
  EventAlertConfig,
  EventAlertConfigUpdate,
  EventInput,
  EventUpdate,
  ExposureFlag,
  GetAccountBankHistoryParams,
  HealthStatus,
  HoldActionResult,
  HoldAlertConfig,
  HoldAlertConfigUpdate,
  HoldRequest,
  IgnoreSaleEmailRequest,
  ImportTicketransferTaskInput,
  IntegrationActionResult,
  InventoryEmailItem,
  InventoryLink,
  InventoryListing,
  InventoryManualFields,
  InventoryReachNote,
  ListAccountsParams,
  ListAuditLogParams,
  ListBankAccountMappingParams,
  ListBankAccountsParams,
  ListBankingAuditParams,
  ListBuybackAccountsParams,
  ListInventoryEmailsParams,
  ListInventoryParams,
  ListPricingGroupsParams,
  ListPricingSectionsParams,
  ListPullersParams,
  ListRefreshRunsParams,
  ListSaleEmailsParams,
  ListSalesParams,
  ListSkyboxEventCandidatesParams,
  ListSkyboxExposureParams,
  ManualFieldsResult,
  ManualMatchRequest,
  MarkBuybackConfirmedBody,
  MarkListedInput,
  MercuryAccount,
  MercuryProvisionInput,
  MicroDeposit,
  MoveToMarketplaceInput,
  NeedHelpInput,
  NotificationPref,
  NotificationPrefUpdate,
  OkResult,
  PhoneTest,
  PhoneTestResult,
  PhoneTypeConfig,
  PhoneTypeUpdate,
  PricingGroup,
  PricingGroupInput,
  PricingGroupUpdate,
  PricingSection,
  PricingVenue,
  Puller,
  PushToReachResult,
  RecentPhoneTests,
  RecommendedPriceInput,
  RecommendedPriceResult,
  RefreshBuybackAccountsInput,
  RefreshBuybackAccountsResult,
  RefreshRequest,
  RefreshRun,
  RematchSaleEmailRequest,
  RematchSalesApplyRequest,
  RematchSalesApplyResult,
  RematchSalesDiff,
  ResolveBanksParams,
  ResolveTicketransferEventInput,
  ResolveTicketransferEventResult,
  ResolvedBank,
  ResyncSaleEmailsRequest,
  ResyncSaleEmailsResult,
  ReviewSaleEmailRequest,
  SaleEmailDetail,
  SaleEmailList,
  SaleEmailRow,
  SalesList,
  SalesStatus,
  SalesSyncStatus,
  SaveSlackMappingsRequest,
  SaveSlackMappingsResult,
  SearchEventCandidatesParams,
  Settings,
  SettingsUpdate,
  SkyboxAlertAllResult,
  SkyboxAlertConfigInput,
  SkyboxAlertPullerPreview,
  SkyboxAlertPullerResult,
  SkyboxEventCandidate,
  SkyboxEventMapping,
  SkyboxMapInput,
  SkyboxSummary,
  SkyboxSyncResult,
  SlackAlertConfig,
  SlackAlertConfigUpdate,
  SlackAutoMapSuggestion,
  SlackChannel,
  SlackUser,
  SyncSalesRequest,
  AmpTicketransferSyncResult,
  SyncSalesSummary,
  TestSlackAlertResult,
  TicketransferTask,
  TicketransferTaskLink,
  VerifyHoldsRequest,
  VirtualBankAccount,
  VirtualBankAccountInput,
  VirtualBankAccountUpdate
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMeUrl = () => {




  return `/api/me`
}

/**
 * @summary Current authenticated user
 */
export const getMe = async ( options?: RequestInit): Promise<CurrentUser> => {

  return customFetch<CurrentUser>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<unknown>


/**
 * @summary Current authenticated user
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetDashboardSummaryUrl = () => {




  return `/api/dashboard/summary`
}

/**
 * @summary Aggregate operator summary across enabled events
 */
export const getDashboardSummary = async ( options?: RequestInit): Promise<DashboardSummary> => {

  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardSummaryQueryKey = () => {
    return [
    `/api/dashboard/summary`
    ] as const;
    }


export const getGetDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryQueryError = ErrorType<unknown>


/**
 * @summary Aggregate operator summary across enabled events
 */

export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListEventsUrl = () => {




  return `/api/events`
}

/**
 * @summary List configured events with summary stats
 */
export const listEvents = async ( options?: RequestInit): Promise<Event[]> => {

  return customFetch<Event[]>(getListEventsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEventsQueryKey = () => {
    return [
    `/api/events`
    ] as const;
    }


export const getListEventsQueryOptions = <TData = Awaited<ReturnType<typeof listEvents>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEventsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvents>>> = ({ signal }) => listEvents({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listEvents>>>
export type ListEventsQueryError = ErrorType<unknown>


/**
 * @summary List configured events with summary stats
 */

export function useListEvents<TData = Awaited<ReturnType<typeof listEvents>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEventsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateEventUrl = () => {




  return `/api/events`
}

/**
 * @summary Add a Reach event
 */
export const createEvent = async (eventInput: EventInput, options?: RequestInit): Promise<Event> => {

  return customFetch<Event>(getCreateEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      eventInput,)
  }
);}




export const getCreateEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEvent>>, TError,{data: BodyType<EventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEvent>>, TError,{data: BodyType<EventInput>}, TContext> => {

const mutationKey = ['createEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEvent>>, {data: BodyType<EventInput>}> = (props) => {
          const {data} = props ?? {};

          return  createEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEventMutationResult = NonNullable<Awaited<ReturnType<typeof createEvent>>>
    export type CreateEventMutationBody = BodyType<EventInput>
    export type CreateEventMutationError = ErrorType<unknown>

    /**
 * @summary Add a Reach event
 */
export const useCreateEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEvent>>, TError,{data: BodyType<EventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEvent>>,
        TError,
        {data: BodyType<EventInput>},
        TContext
      > => {
      return useMutation(getCreateEventMutationOptions(options));
    }

export const getCreateEventsBulkUrl = () => {




  return `/api/events/bulk`
}

/**
 * @summary Bulk-create events (imported disabled by default)
 */
export const createEventsBulk = async (bulkEventInput: BulkEventInput, options?: RequestInit): Promise<Event[]> => {

  return customFetch<Event[]>(getCreateEventsBulkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkEventInput,)
  }
);}




export const getCreateEventsBulkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEventsBulk>>, TError,{data: BodyType<BulkEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEventsBulk>>, TError,{data: BodyType<BulkEventInput>}, TContext> => {

const mutationKey = ['createEventsBulk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEventsBulk>>, {data: BodyType<BulkEventInput>}> = (props) => {
          const {data} = props ?? {};

          return  createEventsBulk(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEventsBulkMutationResult = NonNullable<Awaited<ReturnType<typeof createEventsBulk>>>
    export type CreateEventsBulkMutationBody = BodyType<BulkEventInput>
    export type CreateEventsBulkMutationError = ErrorType<unknown>

    /**
 * @summary Bulk-create events (imported disabled by default)
 */
export const useCreateEventsBulk = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEventsBulk>>, TError,{data: BodyType<BulkEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEventsBulk>>,
        TError,
        {data: BodyType<BulkEventInput>},
        TContext
      > => {
      return useMutation(getCreateEventsBulkMutationOptions(options));
    }

export const getSearchEventCandidatesUrl = (params: SearchEventCandidatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reach/event-search?${stringifiedParams}` : `/api/reach/event-search`
}

/**
 * @summary Search Reach (falling back to Skybox) for upcoming events to import
 */
export const searchEventCandidates = async (params: SearchEventCandidatesParams, options?: RequestInit): Promise<EventCandidate[]> => {

  return customFetch<EventCandidate[]>(getSearchEventCandidatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchEventCandidatesQueryKey = (params?: SearchEventCandidatesParams,) => {
    return [
    `/api/reach/event-search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchEventCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof searchEventCandidates>>, TError = ErrorType<unknown>>(params: SearchEventCandidatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchEventCandidates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchEventCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchEventCandidates>>> = ({ signal }) => searchEventCandidates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchEventCandidates>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchEventCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof searchEventCandidates>>>
export type SearchEventCandidatesQueryError = ErrorType<unknown>


/**
 * @summary Search Reach (falling back to Skybox) for upcoming events to import
 */

export function useSearchEventCandidates<TData = Awaited<ReturnType<typeof searchEventCandidates>>, TError = ErrorType<unknown>>(
 params: SearchEventCandidatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchEventCandidates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchEventCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateEventUrl = (id: number,) => {




  return `/api/events/${id}`
}

/**
 * @summary Update event label, enabled, or sort order
 */
export const updateEvent = async (id: number,
    eventUpdate: EventUpdate, options?: RequestInit): Promise<Event> => {

  return customFetch<Event>(getUpdateEventUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      eventUpdate,)
  }
);}




export const getUpdateEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEvent>>, TError,{id: number;data: BodyType<EventUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEvent>>, TError,{id: number;data: BodyType<EventUpdate>}, TContext> => {

const mutationKey = ['updateEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEvent>>, {id: number;data: BodyType<EventUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEvent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateEvent>>>
    export type UpdateEventMutationBody = BodyType<EventUpdate>
    export type UpdateEventMutationError = ErrorType<unknown>

    /**
 * @summary Update event label, enabled, or sort order
 */
export const useUpdateEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEvent>>, TError,{id: number;data: BodyType<EventUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEvent>>,
        TError,
        {id: number;data: BodyType<EventUpdate>},
        TContext
      > => {
      return useMutation(getUpdateEventMutationOptions(options));
    }

export const getDeleteEventUrl = (id: number,) => {




  return `/api/events/${id}`
}

/**
 * @summary Permanently delete an event and all its cascaded data
 */
export const deleteEvent = async (id: number, options?: RequestInit): Promise<DeleteEvent200> => {

  return customFetch<DeleteEvent200>(getDeleteEventUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEvent>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteEvent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEvent>>>

    export type DeleteEventMutationError = ErrorType<unknown>

    /**
 * @summary Permanently delete an event and all its cascaded data
 */
export const useDeleteEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteEvent>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteEventMutationOptions(options));
    }

export const getGetEventDeletePreviewUrl = (id: number,) => {




  return `/api/events/${id}/delete-preview`
}

/**
 * @summary Counts of data that deleting this event would destroy
 */
export const getEventDeletePreview = async (id: number, options?: RequestInit): Promise<EventDeletePreview> => {

  return customFetch<EventDeletePreview>(getGetEventDeletePreviewUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEventDeletePreviewQueryKey = (id: number,) => {
    return [
    `/api/events/${id}/delete-preview`
    ] as const;
    }


export const getGetEventDeletePreviewQueryOptions = <TData = Awaited<ReturnType<typeof getEventDeletePreview>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDeletePreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventDeletePreviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventDeletePreview>>> = ({ signal }) => getEventDeletePreview(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventDeletePreview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventDeletePreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getEventDeletePreview>>>
export type GetEventDeletePreviewQueryError = ErrorType<unknown>


/**
 * @summary Counts of data that deleting this event would destroy
 */

export function useGetEventDeletePreview<TData = Awaited<ReturnType<typeof getEventDeletePreview>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDeletePreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventDeletePreviewQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRefreshEventUrl = (id: number,) => {




  return `/api/events/${id}/refresh`
}

/**
 * @summary Trigger a refresh for one event
 */
export const refreshEvent = async (id: number,
    refreshRequest?: RefreshRequest, options?: RequestInit): Promise<RefreshRun> => {

  return customFetch<RefreshRun>(getRefreshEventUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refreshRequest,)
  }
);}




export const getRefreshEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshEvent>>, TError,{id: number;data?: BodyType<RefreshRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshEvent>>, TError,{id: number;data?: BodyType<RefreshRequest>}, TContext> => {

const mutationKey = ['refreshEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshEvent>>, {id: number;data?: BodyType<RefreshRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  refreshEvent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshEventMutationResult = NonNullable<Awaited<ReturnType<typeof refreshEvent>>>
    export type RefreshEventMutationBody = BodyType<RefreshRequest> | undefined
    export type RefreshEventMutationError = ErrorType<unknown>

    /**
 * @summary Trigger a refresh for one event
 */
export const useRefreshEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshEvent>>, TError,{id: number;data?: BodyType<RefreshRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshEvent>>,
        TError,
        {id: number;data?: BodyType<RefreshRequest>},
        TContext
      > => {
      return useMutation(getRefreshEventMutationOptions(options));
    }

export const getRefreshFullUrl = () => {




  return `/api/refresh/full`
}

/**
 * @summary Trigger a full refresh across all enabled events
 */
export const refreshFull = async ( options?: RequestInit): Promise<RefreshRun> => {

  return customFetch<RefreshRun>(getRefreshFullUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRefreshFullMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshFull>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshFull>>, TError,void, TContext> => {

const mutationKey = ['refreshFull'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshFull>>, void> = () => {


          return  refreshFull(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshFullMutationResult = NonNullable<Awaited<ReturnType<typeof refreshFull>>>

    export type RefreshFullMutationError = ErrorType<unknown>

    /**
 * @summary Trigger a full refresh across all enabled events
 */
export const useRefreshFull = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshFull>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshFull>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRefreshFullMutationOptions(options));
    }

export const getListEventInventoryUrl = (id: number,) => {




  return `/api/events/${id}/inventory`
}

/**
 * @summary Inventory listings for a single event
 */
export const listEventInventory = async (id: number, options?: RequestInit): Promise<InventoryListing[]> => {

  return customFetch<InventoryListing[]>(getListEventInventoryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEventInventoryQueryKey = (id: number,) => {
    return [
    `/api/events/${id}/inventory`
    ] as const;
    }


export const getListEventInventoryQueryOptions = <TData = Awaited<ReturnType<typeof listEventInventory>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEventInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEventInventoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEventInventory>>> = ({ signal }) => listEventInventory(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEventInventory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEventInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof listEventInventory>>>
export type ListEventInventoryQueryError = ErrorType<unknown>


/**
 * @summary Inventory listings for a single event
 */

export function useListEventInventory<TData = Awaited<ReturnType<typeof listEventInventory>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEventInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEventInventoryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getBulkSetBuybackFveIntentUrl = (id: number,) => {




  return `/api/events/${id}/buyback-fve-intent/bulk`
}

/**
 * @summary Bulk set FVE intent on buyback-eligible listings in an event (operator only)
 */
export const bulkSetBuybackFveIntent = async (id: number,
    bulkBuybackFveIntentInput: BulkBuybackFveIntentInput, options?: RequestInit): Promise<BulkBuybackFveIntentResult> => {

  return customFetch<BulkBuybackFveIntentResult>(getBulkSetBuybackFveIntentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkBuybackFveIntentInput,)
  }
);}




export const getBulkSetBuybackFveIntentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkSetBuybackFveIntent>>, TError,{id: number;data: BodyType<BulkBuybackFveIntentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkSetBuybackFveIntent>>, TError,{id: number;data: BodyType<BulkBuybackFveIntentInput>}, TContext> => {

const mutationKey = ['bulkSetBuybackFveIntent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkSetBuybackFveIntent>>, {id: number;data: BodyType<BulkBuybackFveIntentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  bulkSetBuybackFveIntent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkSetBuybackFveIntentMutationResult = NonNullable<Awaited<ReturnType<typeof bulkSetBuybackFveIntent>>>
    export type BulkSetBuybackFveIntentMutationBody = BodyType<BulkBuybackFveIntentInput>
    export type BulkSetBuybackFveIntentMutationError = ErrorType<unknown>

    /**
 * @summary Bulk set FVE intent on buyback-eligible listings in an event (operator only)
 */
export const useBulkSetBuybackFveIntent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkSetBuybackFveIntent>>, TError,{id: number;data: BodyType<BulkBuybackFveIntentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkSetBuybackFveIntent>>,
        TError,
        {id: number;data: BodyType<BulkBuybackFveIntentInput>},
        TContext
      > => {
      return useMutation(getBulkSetBuybackFveIntentMutationOptions(options));
    }

export const getListInventoryUrl = (params?: ListInventoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory?${stringifiedParams}` : `/api/inventory`
}

/**
 * @summary List inventory across events with filters
 */
export const listInventory = async (params?: ListInventoryParams, options?: RequestInit): Promise<InventoryListing[]> => {

  return customFetch<InventoryListing[]>(getListInventoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryQueryKey = (params?: ListInventoryParams,) => {
    return [
    `/api/inventory`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventoryQueryOptions = <TData = Awaited<ReturnType<typeof listInventory>>, TError = ErrorType<unknown>>(params?: ListInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventory>>> = ({ signal }) => listInventory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof listInventory>>>
export type ListInventoryQueryError = ErrorType<unknown>


/**
 * @summary List inventory across events with filters
 */

export function useListInventory<TData = Awaited<ReturnType<typeof listInventory>>, TError = ErrorType<unknown>>(
 params?: ListInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListPendingRecommendationsUrl = () => {




  return `/api/inventory/pending-recommendations`
}

/**
 * @summary Listings with a recommended-price change awaiting acknowledgment, scoped to the requesting user
 */
export const listPendingRecommendations = async ( options?: RequestInit): Promise<InventoryListing[]> => {

  return customFetch<InventoryListing[]>(getListPendingRecommendationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPendingRecommendationsQueryKey = () => {
    return [
    `/api/inventory/pending-recommendations`
    ] as const;
    }


export const getListPendingRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof listPendingRecommendations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPendingRecommendations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingRecommendationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPendingRecommendations>>> = ({ signal }) => listPendingRecommendations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPendingRecommendations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPendingRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof listPendingRecommendations>>>
export type ListPendingRecommendationsQueryError = ErrorType<unknown>


/**
 * @summary Listings with a recommended-price change awaiting acknowledgment, scoped to the requesting user
 */

export function useListPendingRecommendations<TData = Awaited<ReturnType<typeof listPendingRecommendations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPendingRecommendations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPendingRecommendationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetInventoryUrl = (id: number,) => {




  return `/api/inventory/${id}`
}

/**
 * @summary Get a single inventory listing
 */
export const getInventory = async (id: number, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getGetInventoryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryQueryKey = (id: number,) => {
    return [
    `/api/inventory/${id}`
    ] as const;
    }


export const getGetInventoryQueryOptions = <TData = Awaited<ReturnType<typeof getInventory>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventory>>> = ({ signal }) => getInventory(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof getInventory>>>
export type GetInventoryQueryError = ErrorType<unknown>


/**
 * @summary Get a single inventory listing
 */

export function useGetInventory<TData = Awaited<ReturnType<typeof getInventory>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListInventoryEmailsUrl = (id: number,
    params?: ListInventoryEmailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/${id}/emails?${stringifiedParams}` : `/api/inventory/${id}/emails`
}

/**
 * @summary List the listing/sale emails matched to a listing
 */
export const listInventoryEmails = async (id: number,
    params?: ListInventoryEmailsParams, options?: RequestInit): Promise<InventoryEmailItem[]> => {

  return customFetch<InventoryEmailItem[]>(getListInventoryEmailsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryEmailsQueryKey = (id: number,
    params?: ListInventoryEmailsParams,) => {
    return [
    `/api/inventory/${id}/emails`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventoryEmailsQueryOptions = <TData = Awaited<ReturnType<typeof listInventoryEmails>>, TError = ErrorType<unknown>>(id: number,
    params?: ListInventoryEmailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryEmails>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryEmailsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventoryEmails>>> = ({ signal }) => listInventoryEmails(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventoryEmails>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof listInventoryEmails>>>
export type ListInventoryEmailsQueryError = ErrorType<unknown>


/**
 * @summary List the listing/sale emails matched to a listing
 */

export function useListInventoryEmails<TData = Awaited<ReturnType<typeof listInventoryEmails>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListInventoryEmailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryEmails>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryEmailsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetInventoryReachNoteUrl = (id: number,) => {




  return `/api/inventory/${id}/reach-note`
}

/**
 * @summary Fetch the live "Custom Notes" tag for a listing from Reach
 */
export const getInventoryReachNote = async (id: number, options?: RequestInit): Promise<InventoryReachNote> => {

  return customFetch<InventoryReachNote>(getGetInventoryReachNoteUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryReachNoteQueryKey = (id: number,) => {
    return [
    `/api/inventory/${id}/reach-note`
    ] as const;
    }


export const getGetInventoryReachNoteQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryReachNote>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryReachNote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryReachNoteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryReachNote>>> = ({ signal }) => getInventoryReachNote(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryReachNote>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryReachNoteQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryReachNote>>>
export type GetInventoryReachNoteQueryError = ErrorType<unknown>


/**
 * @summary Fetch the live "Custom Notes" tag for a listing from Reach
 */

export function useGetInventoryReachNote<TData = Awaited<ReturnType<typeof getInventoryReachNote>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryReachNote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryReachNoteQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListInventoryLinksUrl = (id: number,) => {




  return `/api/inventory/${id}/links`
}

/**
 * @summary Per-ticket Ticketransfer delivery links for a listing (domestic)
 */
export const listInventoryLinks = async (id: number, options?: RequestInit): Promise<InventoryLink[]> => {

  return customFetch<InventoryLink[]>(getListInventoryLinksUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryLinksQueryKey = (id: number,) => {
    return [
    `/api/inventory/${id}/links`
    ] as const;
    }


export const getListInventoryLinksQueryOptions = <TData = Awaited<ReturnType<typeof listInventoryLinks>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryLinksQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventoryLinks>>> = ({ signal }) => listInventoryLinks(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventoryLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryLinksQueryResult = NonNullable<Awaited<ReturnType<typeof listInventoryLinks>>>
export type ListInventoryLinksQueryError = ErrorType<unknown>


/**
 * @summary Per-ticket Ticketransfer delivery links for a listing (domestic)
 */

export function useListInventoryLinks<TData = Awaited<ReturnType<typeof listInventoryLinks>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryLinksQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListTicketransferTasksUrl = (params?: { matchedOnly?: boolean }) => {
  const qs = params?.matchedOnly ? '?matchedOnly=true' : '';
  return `/api/ticketransfer/tasks${qs}`
}

/**
 * @summary List imported Ticketransfer tasks
 */
export const listTicketransferTasks = async (params?: { matchedOnly?: boolean }, options?: RequestInit): Promise<TicketransferTask[]> => {

  return customFetch<TicketransferTask[]>(getListTicketransferTasksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTicketransferTasksQueryKey = (params?: { matchedOnly?: boolean }) => {
    return [
    `/api/ticketransfer/tasks`,
    params,
    ] as const;
    }


export const getListTicketransferTasksQueryOptions = <TData = Awaited<ReturnType<typeof listTicketransferTasks>>, TError = ErrorType<unknown>>(params?: { matchedOnly?: boolean }, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTicketransferTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTicketransferTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTicketransferTasks>>> = ({ signal }) => listTicketransferTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTicketransferTasks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTicketransferTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listTicketransferTasks>>>
export type ListTicketransferTasksQueryError = ErrorType<unknown>


/**
 * @summary List imported Ticketransfer tasks
 */

export function useListTicketransferTasks<TData = Awaited<ReturnType<typeof listTicketransferTasks>>, TError = ErrorType<unknown>>(
  params?: { matchedOnly?: boolean },
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTicketransferTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTicketransferTasksQueryOptions(params, options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getImportTicketransferTaskUrl = () => {




  return `/api/ticketransfer/tasks`
}

/**
 * @summary Import (or re-import) a Ticketransfer task by its task id
 */
export const importTicketransferTask = async (importTicketransferTaskInput: ImportTicketransferTaskInput, options?: RequestInit): Promise<TicketransferTask[]> => {

  return customFetch<TicketransferTask[]>(getImportTicketransferTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      importTicketransferTaskInput,)
  }
);}




export const getImportTicketransferTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTicketransferTask>>, TError,{data: BodyType<ImportTicketransferTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importTicketransferTask>>, TError,{data: BodyType<ImportTicketransferTaskInput>}, TContext> => {

const mutationKey = ['importTicketransferTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importTicketransferTask>>, {data: BodyType<ImportTicketransferTaskInput>}> = (props) => {
          const {data} = props ?? {};

          return  importTicketransferTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportTicketransferTaskMutationResult = NonNullable<Awaited<ReturnType<typeof importTicketransferTask>>>
    export type ImportTicketransferTaskMutationBody = BodyType<ImportTicketransferTaskInput>
    export type ImportTicketransferTaskMutationError = ErrorType<unknown>

    /**
 * @summary Import (or re-import) a Ticketransfer task by its task id
 */
export const useImportTicketransferTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTicketransferTask>>, TError,{data: BodyType<ImportTicketransferTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importTicketransferTask>>,
        TError,
        {data: BodyType<ImportTicketransferTaskInput>},
        TContext
      > => {
      return useMutation(getImportTicketransferTaskMutationOptions(options));
    }

export const getDeleteTicketransferTaskUrl = (id: number,) => {




  return `/api/ticketransfer/tasks/${id}`
}

/**
 * @summary Delete an imported task and its links
 */
export const deleteTicketransferTask = async (id: number, options?: RequestInit): Promise<DeleteTicketransferTask200> => {

  return customFetch<DeleteTicketransferTask200>(getDeleteTicketransferTaskUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTicketransferTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTicketransferTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTicketransferTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTicketransferTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTicketransferTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTicketransferTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTicketransferTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTicketransferTask>>>

    export type DeleteTicketransferTaskMutationError = ErrorType<unknown>

    /**
 * @summary Delete an imported task and its links
 */
export const useDeleteTicketransferTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTicketransferTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTicketransferTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTicketransferTaskMutationOptions(options));
    }

export const getRefreshTicketransferTaskUrl = (id: number,) => {




  return `/api/ticketransfer/tasks/${id}/refresh`
}

/**
 * @summary Re-fetch and re-match an imported task from Ticketransfer
 */
export const refreshTicketransferTask = async (id: number, options?: RequestInit): Promise<TicketransferTask> => {

  return customFetch<TicketransferTask>(getRefreshTicketransferTaskUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRefreshTicketransferTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshTicketransferTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshTicketransferTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['refreshTicketransferTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshTicketransferTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  refreshTicketransferTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshTicketransferTaskMutationResult = NonNullable<Awaited<ReturnType<typeof refreshTicketransferTask>>>

    export type RefreshTicketransferTaskMutationError = ErrorType<unknown>

    /**
 * @summary Re-fetch and re-match an imported task from Ticketransfer
 */
export const useRefreshTicketransferTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshTicketransferTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshTicketransferTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRefreshTicketransferTaskMutationOptions(options));
    }

export const getListTicketransferTaskLinksUrl = (id: number,) => {




  return `/api/ticketransfer/tasks/${id}/links`
}

/**
 * @summary List a task's matched links
 */
export const listTicketransferTaskLinks = async (id: number, options?: RequestInit): Promise<TicketransferTaskLink[]> => {

  return customFetch<TicketransferTaskLink[]>(getListTicketransferTaskLinksUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTicketransferTaskLinksQueryKey = (id: number,) => {
    return [
    `/api/ticketransfer/tasks/${id}/links`
    ] as const;
    }


export const getListTicketransferTaskLinksQueryOptions = <TData = Awaited<ReturnType<typeof listTicketransferTaskLinks>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTicketransferTaskLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTicketransferTaskLinksQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTicketransferTaskLinks>>> = ({ signal }) => listTicketransferTaskLinks(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTicketransferTaskLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTicketransferTaskLinksQueryResult = NonNullable<Awaited<ReturnType<typeof listTicketransferTaskLinks>>>
export type ListTicketransferTaskLinksQueryError = ErrorType<unknown>


/**
 * @summary List a task's matched links
 */

export function useListTicketransferTaskLinks<TData = Awaited<ReturnType<typeof listTicketransferTaskLinks>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTicketransferTaskLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTicketransferTaskLinksQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getResolveTicketransferEventUrl = () => {




  return `/api/ticketransfer/resolve-event`
}

/**
 * One-click resolve for an untracked or unmatched Ticketransfer task group. Creates the local event if missing (enabled, domestic), pulls its inventory from Reach, then re-imports every task whose POS event id matches so matching re-runs. Returns the resolved event and its updated tasks.
 * @summary Add/pull a task group's event from Reach and re-run matching
 */
export const resolveTicketransferEvent = async (resolveTicketransferEventInput: ResolveTicketransferEventInput, options?: RequestInit): Promise<ResolveTicketransferEventResult> => {

  return customFetch<ResolveTicketransferEventResult>(getResolveTicketransferEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resolveTicketransferEventInput,)
  }
);}




export const getResolveTicketransferEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveTicketransferEvent>>, TError,{data: BodyType<ResolveTicketransferEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveTicketransferEvent>>, TError,{data: BodyType<ResolveTicketransferEventInput>}, TContext> => {

const mutationKey = ['resolveTicketransferEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveTicketransferEvent>>, {data: BodyType<ResolveTicketransferEventInput>}> = (props) => {
          const {data} = props ?? {};

          return  resolveTicketransferEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveTicketransferEventMutationResult = NonNullable<Awaited<ReturnType<typeof resolveTicketransferEvent>>>
    export type ResolveTicketransferEventMutationBody = BodyType<ResolveTicketransferEventInput>
    export type ResolveTicketransferEventMutationError = ErrorType<unknown>

    /**
 * @summary Add/pull a task group's event from Reach and re-run matching
 */
export const useResolveTicketransferEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveTicketransferEvent>>, TError,{data: BodyType<ResolveTicketransferEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resolveTicketransferEvent>>,
        TError,
        {data: BodyType<ResolveTicketransferEventInput>},
        TContext
      > => {
      return useMutation(getResolveTicketransferEventMutationOptions(options));
    }

export const getSyncTicketransferFromAmpUrl = () => {
  return `/api/ticketransfer/sync-from-amp`
}

/**
 * Trigger an on-demand AMP Ticketransfer sync (admin only). Returns 409 when a sync is already running.
 * @summary On-demand sync of Ticketransfer task IDs from AMP
 */
export const syncTicketransferFromAmp = async (options?: RequestInit): Promise<AmpTicketransferSyncResult> => {
  return customFetch<AmpTicketransferSyncResult>(getSyncTicketransferFromAmpUrl(), {
    ...options,
    method: 'POST',
  });
}

export const getSyncTicketransferFromAmpMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof syncTicketransferFromAmp>>, TError, void, TContext>, request?: SecondParameter<typeof customFetch> }
): UseMutationOptions<Awaited<ReturnType<typeof syncTicketransferFromAmp>>, TError, void, TContext> => {
  const mutationKey = ['syncTicketransferFromAmp'];
  const { mutation: mutationOptions, request: requestOptions } = options ?
    options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncTicketransferFromAmp>>, void> = () => {
    return syncTicketransferFromAmp(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
}

export type SyncTicketransferFromAmpMutationResult = NonNullable<Awaited<ReturnType<typeof syncTicketransferFromAmp>>>
export type SyncTicketransferFromAmpMutationError = ErrorType<unknown>

export const useSyncTicketransferFromAmp = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof syncTicketransferFromAmp>>, TError, void, TContext>, request?: SecondParameter<typeof customFetch> }
): UseMutationResult<
    Awaited<ReturnType<typeof syncTicketransferFromAmp>>,
    TError,
    void,
    TContext
  > => {
  return useMutation(getSyncTicketransferFromAmpMutationOptions(options));
}

export const getUpdateInventoryManualFieldsUrl = (id: number,) => {




  return `/api/inventory/${id}/manual-fields`
}

/**
 * @summary Edit operator-owned manual fields on a listing
 */
export const updateInventoryManualFields = async (id: number,
    inventoryManualFields: InventoryManualFields, options?: RequestInit): Promise<ManualFieldsResult> => {

  return customFetch<ManualFieldsResult>(getUpdateInventoryManualFieldsUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      inventoryManualFields,)
  }
);}




export const getUpdateInventoryManualFieldsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryManualFields>>, TError,{id: number;data: BodyType<InventoryManualFields>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInventoryManualFields>>, TError,{id: number;data: BodyType<InventoryManualFields>}, TContext> => {

const mutationKey = ['updateInventoryManualFields'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInventoryManualFields>>, {id: number;data: BodyType<InventoryManualFields>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInventoryManualFields(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInventoryManualFieldsMutationResult = NonNullable<Awaited<ReturnType<typeof updateInventoryManualFields>>>
    export type UpdateInventoryManualFieldsMutationBody = BodyType<InventoryManualFields>
    export type UpdateInventoryManualFieldsMutationError = ErrorType<unknown>

    /**
 * @summary Edit operator-owned manual fields on a listing
 */
export const useUpdateInventoryManualFields = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryManualFields>>, TError,{id: number;data: BodyType<InventoryManualFields>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInventoryManualFields>>,
        TError,
        {id: number;data: BodyType<InventoryManualFields>},
        TContext
      > => {
      return useMutation(getUpdateInventoryManualFieldsMutationOptions(options));
    }

export const getHoldInventoryUrl = (id: number,) => {




  return `/api/inventory/${id}/hold`
}

/**
 * @summary Place or release admin hold on a single listing
 */
export const holdInventory = async (id: number,
    holdRequest: HoldRequest, options?: RequestInit): Promise<HoldActionResult> => {

  return customFetch<HoldActionResult>(getHoldInventoryUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      holdRequest,)
  }
);}




export const getHoldInventoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof holdInventory>>, TError,{id: number;data: BodyType<HoldRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof holdInventory>>, TError,{id: number;data: BodyType<HoldRequest>}, TContext> => {

const mutationKey = ['holdInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof holdInventory>>, {id: number;data: BodyType<HoldRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  holdInventory(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HoldInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof holdInventory>>>
    export type HoldInventoryMutationBody = BodyType<HoldRequest>
    export type HoldInventoryMutationError = ErrorType<unknown>

    /**
 * @summary Place or release admin hold on a single listing
 */
export const useHoldInventory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof holdInventory>>, TError,{id: number;data: BodyType<HoldRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof holdInventory>>,
        TError,
        {id: number;data: BodyType<HoldRequest>},
        TContext
      > => {
      return useMutation(getHoldInventoryMutationOptions(options));
    }

export const getBulkHoldInventoryUrl = () => {




  return `/api/inventory/bulk-hold`
}

/**
 * @summary Place or release admin hold on many listings
 */
export const bulkHoldInventory = async (bulkHoldRequest: BulkHoldRequest, options?: RequestInit): Promise<BulkHoldResult> => {

  return customFetch<BulkHoldResult>(getBulkHoldInventoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkHoldRequest,)
  }
);}




export const getBulkHoldInventoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkHoldInventory>>, TError,{data: BodyType<BulkHoldRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkHoldInventory>>, TError,{data: BodyType<BulkHoldRequest>}, TContext> => {

const mutationKey = ['bulkHoldInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkHoldInventory>>, {data: BodyType<BulkHoldRequest>}> = (props) => {
          const {data} = props ?? {};

          return  bulkHoldInventory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkHoldInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof bulkHoldInventory>>>
    export type BulkHoldInventoryMutationBody = BodyType<BulkHoldRequest>
    export type BulkHoldInventoryMutationError = ErrorType<unknown>

    /**
 * @summary Place or release admin hold on many listings
 */
export const useBulkHoldInventory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkHoldInventory>>, TError,{data: BodyType<BulkHoldRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkHoldInventory>>,
        TError,
        {data: BodyType<BulkHoldRequest>},
        TContext
      > => {
      return useMutation(getBulkHoldInventoryMutationOptions(options));
    }

export const getSetRecommendedPriceUrl = (id: number,) => {




  return `/api/inventory/${id}/recommended-price`
}

/**
 * @summary Set admin-controlled recommended list price (admin only)
 */
export const setRecommendedPrice = async (id: number,
    recommendedPriceInput: RecommendedPriceInput, options?: RequestInit): Promise<RecommendedPriceResult> => {

  return customFetch<RecommendedPriceResult>(getSetRecommendedPriceUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      recommendedPriceInput,)
  }
);}




export const getSetRecommendedPriceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRecommendedPrice>>, TError,{id: number;data: BodyType<RecommendedPriceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setRecommendedPrice>>, TError,{id: number;data: BodyType<RecommendedPriceInput>}, TContext> => {

const mutationKey = ['setRecommendedPrice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setRecommendedPrice>>, {id: number;data: BodyType<RecommendedPriceInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  setRecommendedPrice(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetRecommendedPriceMutationResult = NonNullable<Awaited<ReturnType<typeof setRecommendedPrice>>>
    export type SetRecommendedPriceMutationBody = BodyType<RecommendedPriceInput>
    export type SetRecommendedPriceMutationError = ErrorType<unknown>

    /**
 * @summary Set admin-controlled recommended list price (admin only)
 */
export const useSetRecommendedPrice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRecommendedPrice>>, TError,{id: number;data: BodyType<RecommendedPriceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setRecommendedPrice>>,
        TError,
        {id: number;data: BodyType<RecommendedPriceInput>},
        TContext
      > => {
      return useMutation(getSetRecommendedPriceMutationOptions(options));
    }

export const getAcknowledgeRecommendedPriceUrl = (id: number,) => {




  return `/api/inventory/${id}/acknowledge-recommended`
}

/**
 * @summary Acknowledge a pending recommended list price change
 */
export const acknowledgeRecommendedPrice = async (id: number, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getAcknowledgeRecommendedPriceUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAcknowledgeRecommendedPriceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgeRecommendedPrice>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acknowledgeRecommendedPrice>>, TError,{id: number}, TContext> => {

const mutationKey = ['acknowledgeRecommendedPrice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acknowledgeRecommendedPrice>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  acknowledgeRecommendedPrice(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcknowledgeRecommendedPriceMutationResult = NonNullable<Awaited<ReturnType<typeof acknowledgeRecommendedPrice>>>

    export type AcknowledgeRecommendedPriceMutationError = ErrorType<unknown>

    /**
 * @summary Acknowledge a pending recommended list price change
 */
export const useAcknowledgeRecommendedPrice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgeRecommendedPrice>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acknowledgeRecommendedPrice>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAcknowledgeRecommendedPriceMutationOptions(options));
    }

export const getMarkListedUrl = (id: number,) => {




  return `/api/inventory/${id}/mark-listed`
}

/**
 * @summary Mark a listing as listed on FVE, optionally recording its FVE list price (operator only)
 */
export const markListed = async (id: number,
    markListedInput?: MarkListedInput, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getMarkListedUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      markListedInput,)
  }
);}




export const getMarkListedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markListed>>, TError,{id: number;data?: BodyType<MarkListedInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markListed>>, TError,{id: number;data?: BodyType<MarkListedInput>}, TContext> => {

const mutationKey = ['markListed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markListed>>, {id: number;data?: BodyType<MarkListedInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  markListed(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkListedMutationResult = NonNullable<Awaited<ReturnType<typeof markListed>>>
    export type MarkListedMutationBody = BodyType<MarkListedInput> | undefined
    export type MarkListedMutationError = ErrorType<unknown>

    /**
 * @summary Mark a listing as listed on FVE, optionally recording its FVE list price (operator only)
 */
export const useMarkListed = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markListed>>, TError,{id: number;data?: BodyType<MarkListedInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markListed>>,
        TError,
        {id: number;data?: BodyType<MarkListedInput>},
        TContext
      > => {
      return useMutation(getMarkListedMutationOptions(options));
    }

export const getUnlistInventoryUrl = (id: number,) => {




  return `/api/inventory/${id}/unlist`
}

/**
 * @summary Remove a listing's FVE listed state (operator only)
 */
export const unlistInventory = async (id: number, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getUnlistInventoryUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnlistInventoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlistInventory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlistInventory>>, TError,{id: number}, TContext> => {

const mutationKey = ['unlistInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlistInventory>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  unlistInventory(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlistInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof unlistInventory>>>

    export type UnlistInventoryMutationError = ErrorType<unknown>

    /**
 * @summary Remove a listing's FVE listed state (operator only)
 */
export const useUnlistInventory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlistInventory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unlistInventory>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getUnlistInventoryMutationOptions(options));
    }

export const getMarkCannotListUrl = (id: number,) => {




  return `/api/inventory/${id}/cannot-list`
}

/**
 * @summary Mark a listing as Cannot List with a required reason (operator only)
 */
export const markCannotList = async (id: number,
    cannotListInput: CannotListInput, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getMarkCannotListUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cannotListInput,)
  }
);}




export const getMarkCannotListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markCannotList>>, TError,{id: number;data: BodyType<CannotListInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markCannotList>>, TError,{id: number;data: BodyType<CannotListInput>}, TContext> => {

const mutationKey = ['markCannotList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markCannotList>>, {id: number;data: BodyType<CannotListInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  markCannotList(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkCannotListMutationResult = NonNullable<Awaited<ReturnType<typeof markCannotList>>>
    export type MarkCannotListMutationBody = BodyType<CannotListInput>
    export type MarkCannotListMutationError = ErrorType<unknown>

    /**
 * @summary Mark a listing as Cannot List with a required reason (operator only)
 */
export const useMarkCannotList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markCannotList>>, TError,{id: number;data: BodyType<CannotListInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markCannotList>>,
        TError,
        {id: number;data: BodyType<CannotListInput>},
        TContext
      > => {
      return useMutation(getMarkCannotListMutationOptions(options));
    }

export const getSetBuybackFveIntentUrl = (id: number,) => {




  return `/api/inventory/${id}/buyback-fve-intent`
}

/**
 * @summary Set the explicit FVE intent for a buyback-eligible listing (operator only)
 */
export const setBuybackFveIntent = async (id: number,
    buybackFveIntentInput: BuybackFveIntentInput, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getSetBuybackFveIntentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      buybackFveIntentInput,)
  }
);}




export const getSetBuybackFveIntentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBuybackFveIntent>>, TError,{id: number;data: BodyType<BuybackFveIntentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setBuybackFveIntent>>, TError,{id: number;data: BodyType<BuybackFveIntentInput>}, TContext> => {

const mutationKey = ['setBuybackFveIntent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setBuybackFveIntent>>, {id: number;data: BodyType<BuybackFveIntentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  setBuybackFveIntent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetBuybackFveIntentMutationResult = NonNullable<Awaited<ReturnType<typeof setBuybackFveIntent>>>
    export type SetBuybackFveIntentMutationBody = BodyType<BuybackFveIntentInput>
    export type SetBuybackFveIntentMutationError = ErrorType<unknown>

    /**
 * @summary Set the explicit FVE intent for a buyback-eligible listing (operator only)
 */
export const useSetBuybackFveIntent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBuybackFveIntent>>, TError,{id: number;data: BodyType<BuybackFveIntentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setBuybackFveIntent>>,
        TError,
        {id: number;data: BodyType<BuybackFveIntentInput>},
        TContext
      > => {
      return useMutation(getSetBuybackFveIntentMutationOptions(options));
    }

export const getFlagNeedHelpUrl = (id: number,) => {




  return `/api/inventory/${id}/need-help`
}

/**
 * @summary Flag a buy_back listing as needing help from another puller
 */
export const flagNeedHelp = async (id: number,
    needHelpInput: NeedHelpInput, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getFlagNeedHelpUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      needHelpInput,)
  }
);}




export const getFlagNeedHelpMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flagNeedHelp>>, TError,{id: number;data: BodyType<NeedHelpInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof flagNeedHelp>>, TError,{id: number;data: BodyType<NeedHelpInput>}, TContext> => {

const mutationKey = ['flagNeedHelp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof flagNeedHelp>>, {id: number;data: BodyType<NeedHelpInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  flagNeedHelp(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FlagNeedHelpMutationResult = NonNullable<Awaited<ReturnType<typeof flagNeedHelp>>>
    export type FlagNeedHelpMutationBody = BodyType<NeedHelpInput>
    export type FlagNeedHelpMutationError = ErrorType<unknown>

    /**
 * @summary Flag a buy_back listing as needing help from another puller
 */
export const useFlagNeedHelp = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flagNeedHelp>>, TError,{id: number;data: BodyType<NeedHelpInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof flagNeedHelp>>,
        TError,
        {id: number;data: BodyType<NeedHelpInput>},
        TContext
      > => {
      return useMutation(getFlagNeedHelpMutationOptions(options));
    }

export const getOfferAssistanceUrl = (id: number,) => {




  return `/api/inventory/${id}/offer-assistance`
}

/**
 * @summary Claim a need-help listing as an assisting puller
 */
export const offerAssistance = async (id: number, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getOfferAssistanceUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getOfferAssistanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerAssistance>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerAssistance>>, TError,{id: number}, TContext> => {

const mutationKey = ['offerAssistance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerAssistance>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  offerAssistance(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferAssistanceMutationResult = NonNullable<Awaited<ReturnType<typeof offerAssistance>>>

    export type OfferAssistanceMutationError = ErrorType<unknown>

    /**
 * @summary Claim a need-help listing as an assisting puller
 */
export const useOfferAssistance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerAssistance>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof offerAssistance>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getOfferAssistanceMutationOptions(options));
    }

export const getListBuybackCandidatesUrl = (id: number,) => {




  return `/api/inventory/${id}/buyback-candidates`
}

/**
 * @summary List ranked buyback account candidates for a listing (operator only)
 */
export const listBuybackCandidates = async (id: number, options?: RequestInit): Promise<BuybackCandidateList> => {

  return customFetch<BuybackCandidateList>(getListBuybackCandidatesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBuybackCandidatesQueryKey = (id: number,) => {
    return [
    `/api/inventory/${id}/buyback-candidates`
    ] as const;
    }


export const getListBuybackCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listBuybackCandidates>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBuybackCandidates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBuybackCandidatesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBuybackCandidates>>> = ({ signal }) => listBuybackCandidates(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBuybackCandidates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBuybackCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listBuybackCandidates>>>
export type ListBuybackCandidatesQueryError = ErrorType<unknown>


/**
 * @summary List ranked buyback account candidates for a listing (operator only)
 */

export function useListBuybackCandidates<TData = Awaited<ReturnType<typeof listBuybackCandidates>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBuybackCandidates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBuybackCandidatesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSetBuybackAccountUrl = (id: number,) => {




  return `/api/inventory/${id}/buyback-account`
}

/**
 * @summary Assign the buyback account for a listing (operator only)
 */
export const setBuybackAccount = async (id: number,
    buybackAccountInput: BuybackAccountInput, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getSetBuybackAccountUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      buybackAccountInput,)
  }
);}




export const getSetBuybackAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBuybackAccount>>, TError,{id: number;data: BodyType<BuybackAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setBuybackAccount>>, TError,{id: number;data: BodyType<BuybackAccountInput>}, TContext> => {

const mutationKey = ['setBuybackAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setBuybackAccount>>, {id: number;data: BodyType<BuybackAccountInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  setBuybackAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetBuybackAccountMutationResult = NonNullable<Awaited<ReturnType<typeof setBuybackAccount>>>
    export type SetBuybackAccountMutationBody = BodyType<BuybackAccountInput>
    export type SetBuybackAccountMutationError = ErrorType<unknown>

    /**
 * @summary Assign the buyback account for a listing (operator only)
 */
export const useSetBuybackAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBuybackAccount>>, TError,{id: number;data: BodyType<BuybackAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setBuybackAccount>>,
        TError,
        {id: number;data: BodyType<BuybackAccountInput>},
        TContext
      > => {
      return useMutation(getSetBuybackAccountMutationOptions(options));
    }

export const getGetBuybackMatchesUrl = (id: number,) => {




  return `/api/inventory/${id}/buyback-matches`
}

/**
 * @summary List the detected buyback purchase matches for a listing (operator only)
 */
export const getBuybackMatches = async (id: number, options?: RequestInit): Promise<BuybackMatchList> => {

  return customFetch<BuybackMatchList>(getGetBuybackMatchesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBuybackMatchesQueryKey = (id: number,) => {
    return [
    `/api/inventory/${id}/buyback-matches`
    ] as const;
    }


export const getGetBuybackMatchesQueryOptions = <TData = Awaited<ReturnType<typeof getBuybackMatches>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBuybackMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuybackMatchesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuybackMatches>>> = ({ signal }) => getBuybackMatches(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBuybackMatches>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBuybackMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof getBuybackMatches>>>
export type GetBuybackMatchesQueryError = ErrorType<unknown>


/**
 * @summary List the detected buyback purchase matches for a listing (operator only)
 */

export function useGetBuybackMatches<TData = Awaited<ReturnType<typeof getBuybackMatches>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBuybackMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBuybackMatchesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCompleteBuybackUrl = (id: number,) => {




  return `/api/inventory/${id}/buyback-complete`
}

/**
 * @summary Complete the buyback reallocation in Reach (operator only)
 */
export const completeBuyback = async (id: number, options?: RequestInit): Promise<BuybackCompleteResult> => {

  return customFetch<BuybackCompleteResult>(getCompleteBuybackUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCompleteBuybackMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeBuyback>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeBuyback>>, TError,{id: number}, TContext> => {

const mutationKey = ['completeBuyback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeBuyback>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  completeBuyback(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteBuybackMutationResult = NonNullable<Awaited<ReturnType<typeof completeBuyback>>>

    export type CompleteBuybackMutationError = ErrorType<unknown>

    /**
 * @summary Complete the buyback reallocation in Reach (operator only)
 */
export const useCompleteBuyback = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeBuyback>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeBuyback>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCompleteBuybackMutationOptions(options));
    }

export const getMarkBuybackFailedUrl = (id: number,) => {




  return `/api/inventory/${id}/buyback-failed`
}

/**
 * @summary Mark a buyback listing as failed to buy back (operator only)
 */
export const markBuybackFailed = async (id: number, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getMarkBuybackFailedUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getMarkBuybackFailedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markBuybackFailed>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markBuybackFailed>>, TError,{id: number}, TContext> => {

const mutationKey = ['markBuybackFailed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markBuybackFailed>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markBuybackFailed(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkBuybackFailedMutationResult = NonNullable<Awaited<ReturnType<typeof markBuybackFailed>>>

    export type MarkBuybackFailedMutationError = ErrorType<unknown>

    /**
 * @summary Mark a buyback listing as failed to buy back (operator only)
 */
export const useMarkBuybackFailed = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markBuybackFailed>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markBuybackFailed>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMarkBuybackFailedMutationOptions(options));
    }

export const getMarkBuybackConfirmedUrl = (id: number,) => {




  return `/api/inventory/${id}/mark-buyback-confirmed`
}

/**
 * @summary Manually confirm a buyback listing was bought back (operator only)
 */
export const markBuybackConfirmed = async (id: number,
    markBuybackConfirmedBody?: MarkBuybackConfirmedBody, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getMarkBuybackConfirmedUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      markBuybackConfirmedBody,)
  }
);}




export const getMarkBuybackConfirmedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markBuybackConfirmed>>, TError,{id: number;data?: BodyType<MarkBuybackConfirmedBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markBuybackConfirmed>>, TError,{id: number;data?: BodyType<MarkBuybackConfirmedBody>}, TContext> => {

const mutationKey = ['markBuybackConfirmed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markBuybackConfirmed>>, {id: number;data?: BodyType<MarkBuybackConfirmedBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  markBuybackConfirmed(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkBuybackConfirmedMutationResult = NonNullable<Awaited<ReturnType<typeof markBuybackConfirmed>>>
    export type MarkBuybackConfirmedMutationBody = BodyType<MarkBuybackConfirmedBody> | undefined
    export type MarkBuybackConfirmedMutationError = ErrorType<unknown>

    /**
 * @summary Manually confirm a buyback listing was bought back (operator only)
 */
export const useMarkBuybackConfirmed = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markBuybackConfirmed>>, TError,{id: number;data?: BodyType<MarkBuybackConfirmedBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markBuybackConfirmed>>,
        TError,
        {id: number;data?: BodyType<MarkBuybackConfirmedBody>},
        TContext
      > => {
      return useMutation(getMarkBuybackConfirmedMutationOptions(options));
    }

export const getDeleteInventorySaleMatchUrl = (id: number,) => {




  return `/api/inventory/${id}/sale-match`
}

/**
 * @summary Unmatch the active sale match from an inventory row, reverting it to pre-sold state (operator only)
 */
export const deleteInventorySaleMatch = async (id: number, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getDeleteInventorySaleMatchUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteInventorySaleMatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventorySaleMatch>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInventorySaleMatch>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteInventorySaleMatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInventorySaleMatch>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteInventorySaleMatch(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInventorySaleMatchMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInventorySaleMatch>>>

    export type DeleteInventorySaleMatchMutationError = ErrorType<unknown>

    /**
 * @summary Unmatch the active sale match from an inventory row, reverting it to pre-sold state (operator only)
 */
export const useDeleteInventorySaleMatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventorySaleMatch>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInventorySaleMatch>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteInventorySaleMatchMutationOptions(options));
    }

export const getSetBuybackGetInUrl = (id: number,) => {




  return `/api/inventory/${id}/buyback-get-in`
}

/**
 * @summary Set the operator get-in price for a buyback-enabled listing (operator only)
 */
export const setBuybackGetIn = async (id: number,
    buybackGetInInput: BuybackGetInInput, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getSetBuybackGetInUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      buybackGetInInput,)
  }
);}




export const getSetBuybackGetInMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBuybackGetIn>>, TError,{id: number;data: BodyType<BuybackGetInInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setBuybackGetIn>>, TError,{id: number;data: BodyType<BuybackGetInInput>}, TContext> => {

const mutationKey = ['setBuybackGetIn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setBuybackGetIn>>, {id: number;data: BodyType<BuybackGetInInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  setBuybackGetIn(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetBuybackGetInMutationResult = NonNullable<Awaited<ReturnType<typeof setBuybackGetIn>>>
    export type SetBuybackGetInMutationBody = BodyType<BuybackGetInInput>
    export type SetBuybackGetInMutationError = ErrorType<unknown>

    /**
 * @summary Set the operator get-in price for a buyback-enabled listing (operator only)
 */
export const useSetBuybackGetIn = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBuybackGetIn>>, TError,{id: number;data: BodyType<BuybackGetInInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setBuybackGetIn>>,
        TError,
        {id: number;data: BodyType<BuybackGetInInput>},
        TContext
      > => {
      return useMutation(getSetBuybackGetInMutationOptions(options));
    }

export const getListBuybackAccountsUrl = (params?: ListBuybackAccountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/buyback-accounts?${stringifiedParams}` : `/api/buyback-accounts`
}

/**
 * @summary List the pre-loaded buy-back account pool, ranked by quality (operator only)
 */
export const listBuybackAccounts = async (params?: ListBuybackAccountsParams, options?: RequestInit): Promise<BuybackAccountList> => {

  return customFetch<BuybackAccountList>(getListBuybackAccountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBuybackAccountsQueryKey = (params?: ListBuybackAccountsParams,) => {
    return [
    `/api/buyback-accounts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBuybackAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listBuybackAccounts>>, TError = ErrorType<unknown>>(params?: ListBuybackAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBuybackAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBuybackAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBuybackAccounts>>> = ({ signal }) => listBuybackAccounts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBuybackAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBuybackAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listBuybackAccounts>>>
export type ListBuybackAccountsQueryError = ErrorType<unknown>


/**
 * @summary List the pre-loaded buy-back account pool, ranked by quality (operator only)
 */

export function useListBuybackAccounts<TData = Awaited<ReturnType<typeof listBuybackAccounts>>, TError = ErrorType<unknown>>(
 params?: ListBuybackAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBuybackAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBuybackAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRefreshBuybackAccountsUrl = () => {




  return `/api/buyback-accounts/refresh`
}

/**
 * @summary Re-pull the buy-back account pool from AMP (operator only)
 */
export const refreshBuybackAccounts = async (refreshBuybackAccountsInput?: RefreshBuybackAccountsInput, options?: RequestInit): Promise<RefreshBuybackAccountsResult> => {

  return customFetch<RefreshBuybackAccountsResult>(getRefreshBuybackAccountsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refreshBuybackAccountsInput,)
  }
);}




export const getRefreshBuybackAccountsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshBuybackAccounts>>, TError,{data?: BodyType<RefreshBuybackAccountsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshBuybackAccounts>>, TError,{data?: BodyType<RefreshBuybackAccountsInput>}, TContext> => {

const mutationKey = ['refreshBuybackAccounts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshBuybackAccounts>>, {data?: BodyType<RefreshBuybackAccountsInput>}> = (props) => {
          const {data} = props ?? {};

          return  refreshBuybackAccounts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshBuybackAccountsMutationResult = NonNullable<Awaited<ReturnType<typeof refreshBuybackAccounts>>>
    export type RefreshBuybackAccountsMutationBody = BodyType<RefreshBuybackAccountsInput> | undefined
    export type RefreshBuybackAccountsMutationError = ErrorType<unknown>

    /**
 * @summary Re-pull the buy-back account pool from AMP (operator only)
 */
export const useRefreshBuybackAccounts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshBuybackAccounts>>, TError,{data?: BodyType<RefreshBuybackAccountsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshBuybackAccounts>>,
        TError,
        {data?: BodyType<RefreshBuybackAccountsInput>},
        TContext
      > => {
      return useMutation(getRefreshBuybackAccountsMutationOptions(options));
    }

export const getGetBuybackRefreshTargetsUrl = () => {




  return `/api/buyback-accounts/refresh-targets`
}

/**
 * @summary List every puller with inventory so the client can chunk an all-pullers pool refresh (operator only)
 */
export const getBuybackRefreshTargets = async ( options?: RequestInit): Promise<BuybackRefreshTargets> => {

  return customFetch<BuybackRefreshTargets>(getGetBuybackRefreshTargetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBuybackRefreshTargetsQueryKey = () => {
    return [
    `/api/buyback-accounts/refresh-targets`
    ] as const;
    }


export const getGetBuybackRefreshTargetsQueryOptions = <TData = Awaited<ReturnType<typeof getBuybackRefreshTargets>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBuybackRefreshTargets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuybackRefreshTargetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuybackRefreshTargets>>> = ({ signal }) => getBuybackRefreshTargets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBuybackRefreshTargets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBuybackRefreshTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof getBuybackRefreshTargets>>>
export type GetBuybackRefreshTargetsQueryError = ErrorType<unknown>


/**
 * @summary List every puller with inventory so the client can chunk an all-pullers pool refresh (operator only)
 */

export function useGetBuybackRefreshTargets<TData = Awaited<ReturnType<typeof getBuybackRefreshTargets>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBuybackRefreshTargets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBuybackRefreshTargetsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRefreshBuybackAccountUrl = (id: number,) => {




  return `/api/buyback-accounts/${id}/refresh`
}

/**
 * @summary Re-pull a single buy-back account from AMP (operator only)
 */
export const refreshBuybackAccount = async (id: number, options?: RequestInit): Promise<BuybackAccount> => {

  return customFetch<BuybackAccount>(getRefreshBuybackAccountUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRefreshBuybackAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshBuybackAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshBuybackAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['refreshBuybackAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshBuybackAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  refreshBuybackAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshBuybackAccountMutationResult = NonNullable<Awaited<ReturnType<typeof refreshBuybackAccount>>>

    export type RefreshBuybackAccountMutationError = ErrorType<unknown>

    /**
 * @summary Re-pull a single buy-back account from AMP (operator only)
 */
export const useRefreshBuybackAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshBuybackAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshBuybackAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRefreshBuybackAccountMutationOptions(options));
    }

export const getTestBuybackAccountPhoneUrl = (id: number,) => {




  return `/api/buyback-accounts/${id}/test-phone`
}

/**
 * @summary Send a test SMS to a buy-back account's phone (operator only)
 */
export const testBuybackAccountPhone = async (id: number, options?: RequestInit): Promise<BuybackPhoneTestResult> => {

  return customFetch<BuybackPhoneTestResult>(getTestBuybackAccountPhoneUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTestBuybackAccountPhoneMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testBuybackAccountPhone>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testBuybackAccountPhone>>, TError,{id: number}, TContext> => {

const mutationKey = ['testBuybackAccountPhone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testBuybackAccountPhone>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  testBuybackAccountPhone(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestBuybackAccountPhoneMutationResult = NonNullable<Awaited<ReturnType<typeof testBuybackAccountPhone>>>

    export type TestBuybackAccountPhoneMutationError = ErrorType<unknown>

    /**
 * @summary Send a test SMS to a buy-back account's phone (operator only)
 */
export const useTestBuybackAccountPhone = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testBuybackAccountPhone>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testBuybackAccountPhone>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getTestBuybackAccountPhoneMutationOptions(options));
    }

export const getUpdateBuybackAccountUrl = (id: number,) => {




  return `/api/buyback-accounts/${id}`
}

/**
 * @summary Override a buy-back account's verified date or phone status (operator only)
 */
export const updateBuybackAccount = async (id: number,
    buybackAccountUpdate: BuybackAccountUpdate, options?: RequestInit): Promise<BuybackAccount> => {

  return customFetch<BuybackAccount>(getUpdateBuybackAccountUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      buybackAccountUpdate,)
  }
);}




export const getUpdateBuybackAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBuybackAccount>>, TError,{id: number;data: BodyType<BuybackAccountUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBuybackAccount>>, TError,{id: number;data: BodyType<BuybackAccountUpdate>}, TContext> => {

const mutationKey = ['updateBuybackAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBuybackAccount>>, {id: number;data: BodyType<BuybackAccountUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBuybackAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBuybackAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateBuybackAccount>>>
    export type UpdateBuybackAccountMutationBody = BodyType<BuybackAccountUpdate>
    export type UpdateBuybackAccountMutationError = ErrorType<unknown>

    /**
 * @summary Override a buy-back account's verified date or phone status (operator only)
 */
export const useUpdateBuybackAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBuybackAccount>>, TError,{id: number;data: BodyType<BuybackAccountUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBuybackAccount>>,
        TError,
        {id: number;data: BodyType<BuybackAccountUpdate>},
        TContext
      > => {
      return useMutation(getUpdateBuybackAccountMutationOptions(options));
    }

export const getMoveToMarketplaceUrl = (id: number,) => {




  return `/api/inventory/${id}/move-to-marketplace`
}

/**
 * @summary Redirect a held/listed listing to an external marketplace (operator only)
 */
export const moveToMarketplace = async (id: number,
    moveToMarketplaceInput: MoveToMarketplaceInput, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getMoveToMarketplaceUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      moveToMarketplaceInput,)
  }
);}




export const getMoveToMarketplaceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveToMarketplace>>, TError,{id: number;data: BodyType<MoveToMarketplaceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof moveToMarketplace>>, TError,{id: number;data: BodyType<MoveToMarketplaceInput>}, TContext> => {

const mutationKey = ['moveToMarketplace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveToMarketplace>>, {id: number;data: BodyType<MoveToMarketplaceInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  moveToMarketplace(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveToMarketplaceMutationResult = NonNullable<Awaited<ReturnType<typeof moveToMarketplace>>>
    export type MoveToMarketplaceMutationBody = BodyType<MoveToMarketplaceInput>
    export type MoveToMarketplaceMutationError = ErrorType<unknown>

    /**
 * @summary Redirect a held/listed listing to an external marketplace (operator only)
 */
export const useMoveToMarketplace = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveToMarketplace>>, TError,{id: number;data: BodyType<MoveToMarketplaceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof moveToMarketplace>>,
        TError,
        {id: number;data: BodyType<MoveToMarketplaceInput>},
        TContext
      > => {
      return useMutation(getMoveToMarketplaceMutationOptions(options));
    }

export const getReEnableInventoryUrl = (id: number,) => {




  return `/api/inventory/${id}/re-enable`
}

/**
 * @summary Clear a Cannot List reason and restore the prior derived state (operator only)
 */
export const reEnableInventory = async (id: number, options?: RequestInit): Promise<InventoryListing> => {

  return customFetch<InventoryListing>(getReEnableInventoryUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReEnableInventoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reEnableInventory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reEnableInventory>>, TError,{id: number}, TContext> => {

const mutationKey = ['reEnableInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reEnableInventory>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  reEnableInventory(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReEnableInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof reEnableInventory>>>

    export type ReEnableInventoryMutationError = ErrorType<unknown>

    /**
 * @summary Clear a Cannot List reason and restore the prior derived state (operator only)
 */
export const useReEnableInventory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reEnableInventory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reEnableInventory>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getReEnableInventoryMutationOptions(options));
    }

export const getVerifyHoldsUrl = () => {




  return `/api/inventory/verify-holds`
}

/**
 * @summary Read back and verify hold state for listings
 */
export const verifyHolds = async (verifyHoldsRequest: VerifyHoldsRequest, options?: RequestInit): Promise<BulkHoldResult> => {

  return customFetch<BulkHoldResult>(getVerifyHoldsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      verifyHoldsRequest,)
  }
);}




export const getVerifyHoldsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyHolds>>, TError,{data: BodyType<VerifyHoldsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyHolds>>, TError,{data: BodyType<VerifyHoldsRequest>}, TContext> => {

const mutationKey = ['verifyHolds'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyHolds>>, {data: BodyType<VerifyHoldsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  verifyHolds(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyHoldsMutationResult = NonNullable<Awaited<ReturnType<typeof verifyHolds>>>
    export type VerifyHoldsMutationBody = BodyType<VerifyHoldsRequest>
    export type VerifyHoldsMutationError = ErrorType<unknown>

    /**
 * @summary Read back and verify hold state for listings
 */
export const useVerifyHolds = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyHolds>>, TError,{data: BodyType<VerifyHoldsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyHolds>>,
        TError,
        {data: BodyType<VerifyHoldsRequest>},
        TContext
      > => {
      return useMutation(getVerifyHoldsMutationOptions(options));
    }

export const getListPricingVenuesUrl = () => {




  return `/api/pricing/venues`
}

/**
 * @summary Distinct venues (with city) drawn from inventory
 */
export const listPricingVenues = async ( options?: RequestInit): Promise<PricingVenue[]> => {

  return customFetch<PricingVenue[]>(getListPricingVenuesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingVenuesQueryKey = () => {
    return [
    `/api/pricing/venues`
    ] as const;
    }


export const getListPricingVenuesQueryOptions = <TData = Awaited<ReturnType<typeof listPricingVenues>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingVenues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingVenuesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingVenues>>> = ({ signal }) => listPricingVenues({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingVenues>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingVenuesQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingVenues>>>
export type ListPricingVenuesQueryError = ErrorType<unknown>


/**
 * @summary Distinct venues (with city) drawn from inventory
 */

export function useListPricingVenues<TData = Awaited<ReturnType<typeof listPricingVenues>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingVenues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingVenuesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListPricingSectionsUrl = (params: ListPricingSectionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pricing/sections?${stringifiedParams}` : `/api/pricing/sections`
}

/**
 * @summary Distinct sections (GA-normalised) and their rows at a venue
 */
export const listPricingSections = async (params: ListPricingSectionsParams, options?: RequestInit): Promise<PricingSection[]> => {

  return customFetch<PricingSection[]>(getListPricingSectionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingSectionsQueryKey = (params?: ListPricingSectionsParams,) => {
    return [
    `/api/pricing/sections`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPricingSectionsQueryOptions = <TData = Awaited<ReturnType<typeof listPricingSections>>, TError = ErrorType<unknown>>(params: ListPricingSectionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingSections>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingSectionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingSections>>> = ({ signal }) => listPricingSections(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingSections>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingSectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingSections>>>
export type ListPricingSectionsQueryError = ErrorType<unknown>


/**
 * @summary Distinct sections (GA-normalised) and their rows at a venue
 */

export function useListPricingSections<TData = Awaited<ReturnType<typeof listPricingSections>>, TError = ErrorType<unknown>>(
 params: ListPricingSectionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingSections>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingSectionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListPricingGroupsUrl = (params?: ListPricingGroupsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pricing/groups?${stringifiedParams}` : `/api/pricing/groups`
}

/**
 * @summary Pricing groups for a venue
 */
export const listPricingGroups = async (params?: ListPricingGroupsParams, options?: RequestInit): Promise<PricingGroup[]> => {

  return customFetch<PricingGroup[]>(getListPricingGroupsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingGroupsQueryKey = (params?: ListPricingGroupsParams,) => {
    return [
    `/api/pricing/groups`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPricingGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listPricingGroups>>, TError = ErrorType<unknown>>(params?: ListPricingGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingGroups>>> = ({ signal }) => listPricingGroups(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingGroups>>>
export type ListPricingGroupsQueryError = ErrorType<unknown>


/**
 * @summary Pricing groups for a venue
 */

export function useListPricingGroups<TData = Awaited<ReturnType<typeof listPricingGroups>>, TError = ErrorType<unknown>>(
 params?: ListPricingGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePricingGroupUrl = () => {




  return `/api/pricing/groups`
}

/**
 * @summary Create a pricing group
 */
export const createPricingGroup = async (pricingGroupInput: PricingGroupInput, options?: RequestInit): Promise<PricingGroup> => {

  return customFetch<PricingGroup>(getCreatePricingGroupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pricingGroupInput,)
  }
);}




export const getCreatePricingGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingGroup>>, TError,{data: BodyType<PricingGroupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPricingGroup>>, TError,{data: BodyType<PricingGroupInput>}, TContext> => {

const mutationKey = ['createPricingGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPricingGroup>>, {data: BodyType<PricingGroupInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPricingGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePricingGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createPricingGroup>>>
    export type CreatePricingGroupMutationBody = BodyType<PricingGroupInput>
    export type CreatePricingGroupMutationError = ErrorType<unknown>

    /**
 * @summary Create a pricing group
 */
export const useCreatePricingGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingGroup>>, TError,{data: BodyType<PricingGroupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPricingGroup>>,
        TError,
        {data: BodyType<PricingGroupInput>},
        TContext
      > => {
      return useMutation(getCreatePricingGroupMutationOptions(options));
    }

export const getUpdatePricingGroupUrl = (id: number,) => {




  return `/api/pricing/groups/${id}`
}

/**
 * @summary Rename a group or replace its members
 */
export const updatePricingGroup = async (id: number,
    pricingGroupUpdate: PricingGroupUpdate, options?: RequestInit): Promise<PricingGroup> => {

  return customFetch<PricingGroup>(getUpdatePricingGroupUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pricingGroupUpdate,)
  }
);}




export const getUpdatePricingGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingGroup>>, TError,{id: number;data: BodyType<PricingGroupUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePricingGroup>>, TError,{id: number;data: BodyType<PricingGroupUpdate>}, TContext> => {

const mutationKey = ['updatePricingGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePricingGroup>>, {id: number;data: BodyType<PricingGroupUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePricingGroup(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePricingGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updatePricingGroup>>>
    export type UpdatePricingGroupMutationBody = BodyType<PricingGroupUpdate>
    export type UpdatePricingGroupMutationError = ErrorType<unknown>

    /**
 * @summary Rename a group or replace its members
 */
export const useUpdatePricingGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingGroup>>, TError,{id: number;data: BodyType<PricingGroupUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePricingGroup>>,
        TError,
        {id: number;data: BodyType<PricingGroupUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePricingGroupMutationOptions(options));
    }

export const getDeletePricingGroupUrl = (id: number,) => {




  return `/api/pricing/groups/${id}`
}

/**
 * @summary Delete a pricing group
 */
export const deletePricingGroup = async (id: number, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDeletePricingGroupUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePricingGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePricingGroup>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePricingGroup>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePricingGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePricingGroup>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePricingGroup(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePricingGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deletePricingGroup>>>

    export type DeletePricingGroupMutationError = ErrorType<unknown>

    /**
 * @summary Delete a pricing group
 */
export const useDeletePricingGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePricingGroup>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePricingGroup>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePricingGroupMutationOptions(options));
    }

export const getBulkPushPricingUrl = () => {




  return `/api/pricing/bulk-push`
}

/**
 * @summary Push bulk recommended prices to a group or sections and notify pullers
 */
export const bulkPushPricing = async (bulkPricePushInput: BulkPricePushInput, options?: RequestInit): Promise<BulkPricePushResult> => {

  return customFetch<BulkPricePushResult>(getBulkPushPricingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkPricePushInput,)
  }
);}




export const getBulkPushPricingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkPushPricing>>, TError,{data: BodyType<BulkPricePushInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkPushPricing>>, TError,{data: BodyType<BulkPricePushInput>}, TContext> => {

const mutationKey = ['bulkPushPricing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkPushPricing>>, {data: BodyType<BulkPricePushInput>}> = (props) => {
          const {data} = props ?? {};

          return  bulkPushPricing(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkPushPricingMutationResult = NonNullable<Awaited<ReturnType<typeof bulkPushPricing>>>
    export type BulkPushPricingMutationBody = BodyType<BulkPricePushInput>
    export type BulkPushPricingMutationError = ErrorType<unknown>

    /**
 * @summary Push bulk recommended prices to a group or sections and notify pullers
 */
export const useBulkPushPricing = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkPushPricing>>, TError,{data: BodyType<BulkPricePushInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkPushPricing>>,
        TError,
        {data: BodyType<BulkPricePushInput>},
        TContext
      > => {
      return useMutation(getBulkPushPricingMutationOptions(options));
    }

export const getGetSkyboxSummaryUrl = () => {




  return `/api/skybox/summary`
}

/**
 * @summary Skybox integration status and exposure totals
 */
export const getSkyboxSummary = async ( options?: RequestInit): Promise<SkyboxSummary> => {

  return customFetch<SkyboxSummary>(getGetSkyboxSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSkyboxSummaryQueryKey = () => {
    return [
    `/api/skybox/summary`
    ] as const;
    }


export const getGetSkyboxSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getSkyboxSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSkyboxSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSkyboxSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSkyboxSummary>>> = ({ signal }) => getSkyboxSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSkyboxSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSkyboxSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getSkyboxSummary>>>
export type GetSkyboxSummaryQueryError = ErrorType<unknown>


/**
 * @summary Skybox integration status and exposure totals
 */

export function useGetSkyboxSummary<TData = Awaited<ReturnType<typeof getSkyboxSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSkyboxSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSkyboxSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListSkyboxEventsUrl = () => {




  return `/api/skybox/events`
}

/**
 * @summary FVE events with their Skybox mapping and open-flag counts
 */
export const listSkyboxEvents = async ( options?: RequestInit): Promise<SkyboxEventMapping[]> => {

  return customFetch<SkyboxEventMapping[]>(getListSkyboxEventsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSkyboxEventsQueryKey = () => {
    return [
    `/api/skybox/events`
    ] as const;
    }


export const getListSkyboxEventsQueryOptions = <TData = Awaited<ReturnType<typeof listSkyboxEvents>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSkyboxEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSkyboxEventsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSkyboxEvents>>> = ({ signal }) => listSkyboxEvents({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSkyboxEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSkyboxEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listSkyboxEvents>>>
export type ListSkyboxEventsQueryError = ErrorType<unknown>


/**
 * @summary FVE events with their Skybox mapping and open-flag counts
 */

export function useListSkyboxEvents<TData = Awaited<ReturnType<typeof listSkyboxEvents>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSkyboxEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSkyboxEventsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListSkyboxEventCandidatesUrl = (params: ListSkyboxEventCandidatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/skybox/event-candidates?${stringifiedParams}` : `/api/skybox/event-candidates`
}

/**
 * @summary Candidate Skybox catalog events for mapping an FVE event
 */
export const listSkyboxEventCandidates = async (params: ListSkyboxEventCandidatesParams, options?: RequestInit): Promise<SkyboxEventCandidate[]> => {

  return customFetch<SkyboxEventCandidate[]>(getListSkyboxEventCandidatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSkyboxEventCandidatesQueryKey = (params?: ListSkyboxEventCandidatesParams,) => {
    return [
    `/api/skybox/event-candidates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSkyboxEventCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listSkyboxEventCandidates>>, TError = ErrorType<unknown>>(params: ListSkyboxEventCandidatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSkyboxEventCandidates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSkyboxEventCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSkyboxEventCandidates>>> = ({ signal }) => listSkyboxEventCandidates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSkyboxEventCandidates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSkyboxEventCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listSkyboxEventCandidates>>>
export type ListSkyboxEventCandidatesQueryError = ErrorType<unknown>


/**
 * @summary Candidate Skybox catalog events for mapping an FVE event
 */

export function useListSkyboxEventCandidates<TData = Awaited<ReturnType<typeof listSkyboxEventCandidates>>, TError = ErrorType<unknown>>(
 params: ListSkyboxEventCandidatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSkyboxEventCandidates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSkyboxEventCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getMapSkyboxEventUrl = (skyboxEventId: string,) => {




  return `/api/skybox/events/${skyboxEventId}/map`
}

/**
 * @summary Manually map (or unmap) a Skybox event to an FVE event
 */
export const mapSkyboxEvent = async (skyboxEventId: string,
    skyboxMapInput: SkyboxMapInput, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getMapSkyboxEventUrl(skyboxEventId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      skyboxMapInput,)
  }
);}




export const getMapSkyboxEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapSkyboxEvent>>, TError,{skyboxEventId: string;data: BodyType<SkyboxMapInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mapSkyboxEvent>>, TError,{skyboxEventId: string;data: BodyType<SkyboxMapInput>}, TContext> => {

const mutationKey = ['mapSkyboxEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mapSkyboxEvent>>, {skyboxEventId: string;data: BodyType<SkyboxMapInput>}> = (props) => {
          const {skyboxEventId,data} = props ?? {};

          return  mapSkyboxEvent(skyboxEventId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MapSkyboxEventMutationResult = NonNullable<Awaited<ReturnType<typeof mapSkyboxEvent>>>
    export type MapSkyboxEventMutationBody = BodyType<SkyboxMapInput>
    export type MapSkyboxEventMutationError = ErrorType<unknown>

    /**
 * @summary Manually map (or unmap) a Skybox event to an FVE event
 */
export const useMapSkyboxEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapSkyboxEvent>>, TError,{skyboxEventId: string;data: BodyType<SkyboxMapInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof mapSkyboxEvent>>,
        TError,
        {skyboxEventId: string;data: BodyType<SkyboxMapInput>},
        TContext
      > => {
      return useMutation(getMapSkyboxEventMutationOptions(options));
    }

export const getListSkyboxExposureUrl = (params?: ListSkyboxExposureParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/skybox/exposure?${stringifiedParams}` : `/api/skybox/exposure`
}

/**
 * @summary Detected double-exposure flags
 */
export const listSkyboxExposure = async (params?: ListSkyboxExposureParams, options?: RequestInit): Promise<ExposureFlag[]> => {

  return customFetch<ExposureFlag[]>(getListSkyboxExposureUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSkyboxExposureQueryKey = (params?: ListSkyboxExposureParams,) => {
    return [
    `/api/skybox/exposure`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSkyboxExposureQueryOptions = <TData = Awaited<ReturnType<typeof listSkyboxExposure>>, TError = ErrorType<unknown>>(params?: ListSkyboxExposureParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSkyboxExposure>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSkyboxExposureQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSkyboxExposure>>> = ({ signal }) => listSkyboxExposure(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSkyboxExposure>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSkyboxExposureQueryResult = NonNullable<Awaited<ReturnType<typeof listSkyboxExposure>>>
export type ListSkyboxExposureQueryError = ErrorType<unknown>


/**
 * @summary Detected double-exposure flags
 */

export function useListSkyboxExposure<TData = Awaited<ReturnType<typeof listSkyboxExposure>>, TError = ErrorType<unknown>>(
 params?: ListSkyboxExposureParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSkyboxExposure>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSkyboxExposureQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSyncSkyboxUrl = () => {




  return `/api/skybox/sync`
}

/**
 * @summary Run a Skybox sync (resolve mappings, ingest, reconcile)
 */
export const syncSkybox = async ( options?: RequestInit): Promise<SkyboxSyncResult> => {

  return customFetch<SkyboxSyncResult>(getSyncSkyboxUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSyncSkyboxMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSkybox>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncSkybox>>, TError,void, TContext> => {

const mutationKey = ['syncSkybox'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncSkybox>>, void> = () => {


          return  syncSkybox(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncSkyboxMutationResult = NonNullable<Awaited<ReturnType<typeof syncSkybox>>>

    export type SyncSkyboxMutationError = ErrorType<unknown>

    /**
 * @summary Run a Skybox sync (resolve mappings, ingest, reconcile)
 */
export const useSyncSkybox = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSkybox>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncSkybox>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncSkyboxMutationOptions(options));
    }

export const getUpdateSkyboxAlertConfigUrl = () => {




  return `/api/skybox/alert-config`
}

/**
 * @summary Enable/disable the global Skybox exposure Slack alert
 */
export const updateSkyboxAlertConfig = async (skyboxAlertConfigInput: SkyboxAlertConfigInput, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getUpdateSkyboxAlertConfigUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      skyboxAlertConfigInput,)
  }
);}




export const getUpdateSkyboxAlertConfigMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSkyboxAlertConfig>>, TError,{data: BodyType<SkyboxAlertConfigInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSkyboxAlertConfig>>, TError,{data: BodyType<SkyboxAlertConfigInput>}, TContext> => {

const mutationKey = ['updateSkyboxAlertConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSkyboxAlertConfig>>, {data: BodyType<SkyboxAlertConfigInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateSkyboxAlertConfig(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSkyboxAlertConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateSkyboxAlertConfig>>>
    export type UpdateSkyboxAlertConfigMutationBody = BodyType<SkyboxAlertConfigInput>
    export type UpdateSkyboxAlertConfigMutationError = ErrorType<unknown>

    /**
 * @summary Enable/disable the global Skybox exposure Slack alert
 */
export const useUpdateSkyboxAlertConfig = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSkyboxAlertConfig>>, TError,{data: BodyType<SkyboxAlertConfigInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSkyboxAlertConfig>>,
        TError,
        {data: BodyType<SkyboxAlertConfigInput>},
        TContext
      > => {
      return useMutation(getUpdateSkyboxAlertConfigMutationOptions(options));
    }

export const getGetSkyboxAlertPullerPreviewUrl = (id: number,) => {




  return `/api/skybox/flags/${id}/alert-puller`
}

/**
 * @summary Preview the "alert puller" Slack message for an exposure flag
 */
export const getSkyboxAlertPullerPreview = async (id: number, options?: RequestInit): Promise<SkyboxAlertPullerPreview> => {

  return customFetch<SkyboxAlertPullerPreview>(getGetSkyboxAlertPullerPreviewUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSkyboxAlertPullerPreviewQueryKey = (id: number,) => {
    return [
    `/api/skybox/flags/${id}/alert-puller`
    ] as const;
    }


export const getGetSkyboxAlertPullerPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getSkyboxAlertPullerPreview>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSkyboxAlertPullerPreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSkyboxAlertPullerPreviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSkyboxAlertPullerPreview>>> = ({ signal }) => getSkyboxAlertPullerPreview(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSkyboxAlertPullerPreview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSkyboxAlertPullerPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getSkyboxAlertPullerPreview>>>
export type GetSkyboxAlertPullerPreviewQueryError = ErrorType<unknown>


/**
 * @summary Preview the "alert puller" Slack message for an exposure flag
 */

export function useGetSkyboxAlertPullerPreview<TData = Awaited<ReturnType<typeof getSkyboxAlertPullerPreview>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSkyboxAlertPullerPreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSkyboxAlertPullerPreviewQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSendSkyboxAlertPullerUrl = (id: number,) => {




  return `/api/skybox/flags/${id}/alert-puller`
}

/**
 * @summary Send the "alert puller" Slack message for an exposure flag
 */
export const sendSkyboxAlertPuller = async (id: number, options?: RequestInit): Promise<SkyboxAlertPullerResult> => {

  return customFetch<SkyboxAlertPullerResult>(getSendSkyboxAlertPullerUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSendSkyboxAlertPullerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSkyboxAlertPuller>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendSkyboxAlertPuller>>, TError,{id: number}, TContext> => {

const mutationKey = ['sendSkyboxAlertPuller'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSkyboxAlertPuller>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  sendSkyboxAlertPuller(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendSkyboxAlertPullerMutationResult = NonNullable<Awaited<ReturnType<typeof sendSkyboxAlertPuller>>>

    export type SendSkyboxAlertPullerMutationError = ErrorType<unknown>

    /**
 * @summary Send the "alert puller" Slack message for an exposure flag
 */
export const useSendSkyboxAlertPuller = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSkyboxAlertPuller>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendSkyboxAlertPuller>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getSendSkyboxAlertPullerMutationOptions(options));
    }

export const getSendSkyboxAlertAllUrl = () => {




  return `/api/skybox/alert-all`
}

/**
 * @summary Refresh Skybox data, then alert every puller with a currently-listed exposure
 */
export const sendSkyboxAlertAll = async ( options?: RequestInit): Promise<SkyboxAlertAllResult> => {

  return customFetch<SkyboxAlertAllResult>(getSendSkyboxAlertAllUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSendSkyboxAlertAllMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSkyboxAlertAll>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendSkyboxAlertAll>>, TError,void, TContext> => {

const mutationKey = ['sendSkyboxAlertAll'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSkyboxAlertAll>>, void> = () => {


          return  sendSkyboxAlertAll(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendSkyboxAlertAllMutationResult = NonNullable<Awaited<ReturnType<typeof sendSkyboxAlertAll>>>

    export type SendSkyboxAlertAllMutationError = ErrorType<unknown>

    /**
 * @summary Refresh Skybox data, then alert every puller with a currently-listed exposure
 */
export const useSendSkyboxAlertAll = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSkyboxAlertAll>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendSkyboxAlertAll>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSendSkyboxAlertAllMutationOptions(options));
    }

export const getListAccountsUrl = (params?: ListAccountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/accounts?${stringifiedParams}` : `/api/accounts`
}

/**
 * @summary List vendor accounts
 */
export const listAccounts = async (params?: ListAccountsParams, options?: RequestInit): Promise<Account[]> => {

  return customFetch<Account[]>(getListAccountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountsQueryKey = (params?: ListAccountsParams,) => {
    return [
    `/api/accounts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listAccounts>>, TError = ErrorType<unknown>>(params?: ListAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccounts>>> = ({ signal }) => listAccounts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccounts>>>
export type ListAccountsQueryError = ErrorType<unknown>


/**
 * @summary List vendor accounts
 */

export function useListAccounts<TData = Awaited<ReturnType<typeof listAccounts>>, TError = ErrorType<unknown>>(
 params?: ListAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAccountUrl = (id: number,) => {




  return `/api/accounts/${id}`
}

/**
 * @summary Account detail
 */
export const getAccount = async (id: number, options?: RequestInit): Promise<AccountDetail> => {

  return customFetch<AccountDetail>(getGetAccountUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountQueryKey = (id: number,) => {
    return [
    `/api/accounts/${id}`
    ] as const;
    }


export const getGetAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({ signal }) => getAccount(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccount>>>
export type GetAccountQueryError = ErrorType<unknown>


/**
 * @summary Account detail
 */

export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAccountUrl = (id: number,) => {




  return `/api/accounts/${id}`
}

/**
 * @summary Update editable account fields
 */
export const updateAccount = async (id: number,
    accountUpdate: AccountUpdate, options?: RequestInit): Promise<Account> => {

  return customFetch<Account>(getUpdateAccountUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountUpdate,)
  }
);}




export const getUpdateAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{id: number;data: BodyType<AccountUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{id: number;data: BodyType<AccountUpdate>}, TContext> => {

const mutationKey = ['updateAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccount>>, {id: number;data: BodyType<AccountUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccount>>>
    export type UpdateAccountMutationBody = BodyType<AccountUpdate>
    export type UpdateAccountMutationError = ErrorType<unknown>

    /**
 * @summary Update editable account fields
 */
export const useUpdateAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{id: number;data: BodyType<AccountUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAccount>>,
        TError,
        {id: number;data: BodyType<AccountUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAccountMutationOptions(options));
    }

export const getRefreshAccountAmpUrl = (id: number,) => {




  return `/api/accounts/${id}/refresh-amp`
}

/**
 * @summary Refresh a single account from AMP
 */
export const refreshAccountAmp = async (id: number, options?: RequestInit): Promise<Account> => {

  return customFetch<Account>(getRefreshAccountAmpUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRefreshAccountAmpMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccountAmp>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshAccountAmp>>, TError,{id: number}, TContext> => {

const mutationKey = ['refreshAccountAmp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshAccountAmp>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  refreshAccountAmp(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshAccountAmpMutationResult = NonNullable<Awaited<ReturnType<typeof refreshAccountAmp>>>

    export type RefreshAccountAmpMutationError = ErrorType<unknown>

    /**
 * @summary Refresh a single account from AMP
 */
export const useRefreshAccountAmp = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccountAmp>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshAccountAmp>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRefreshAccountAmpMutationOptions(options));
    }

export const getTestAccountPhoneUrl = (id: number,) => {




  return `/api/accounts/${id}/test-phone`
}

/**
 * @summary Send a test SMS to an account's phone and schedule an AMP recheck
 */
export const testAccountPhone = async (id: number, options?: RequestInit): Promise<PhoneTestResult> => {

  return customFetch<PhoneTestResult>(getTestAccountPhoneUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTestAccountPhoneMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testAccountPhone>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testAccountPhone>>, TError,{id: number}, TContext> => {

const mutationKey = ['testAccountPhone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testAccountPhone>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  testAccountPhone(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestAccountPhoneMutationResult = NonNullable<Awaited<ReturnType<typeof testAccountPhone>>>

    export type TestAccountPhoneMutationError = ErrorType<unknown>

    /**
 * @summary Send a test SMS to an account's phone and schedule an AMP recheck
 */
export const useTestAccountPhone = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testAccountPhone>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testAccountPhone>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getTestAccountPhoneMutationOptions(options));
    }

export const getBackfillPhoneTagsUrl = () => {




  return `/api/admin/backfill-phone-tags`
}

/**
 * @summary Re-sync the Reach Phone Status tag for all accounts with a known phone health
 */
export const backfillPhoneTags = async ( options?: RequestInit): Promise<BackfillPhoneTagsResult> => {

  return customFetch<BackfillPhoneTagsResult>(getBackfillPhoneTagsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getBackfillPhoneTagsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backfillPhoneTags>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof backfillPhoneTags>>, TError,void, TContext> => {

const mutationKey = ['backfillPhoneTags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof backfillPhoneTags>>, void> = () => {


          return  backfillPhoneTags(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BackfillPhoneTagsMutationResult = NonNullable<Awaited<ReturnType<typeof backfillPhoneTags>>>

    export type BackfillPhoneTagsMutationError = ErrorType<unknown>

    /**
 * @summary Re-sync the Reach Phone Status tag for all accounts with a known phone health
 */
export const useBackfillPhoneTags = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backfillPhoneTags>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof backfillPhoneTags>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getBackfillPhoneTagsMutationOptions(options));
    }

export const getBulkTestPhonesUrl = () => {




  return `/api/phone-tests/bulk`
}

/**
 * @summary Queue throttled test SMS for all eligible automated-phone accounts
 */
export const bulkTestPhones = async ( options?: RequestInit): Promise<BulkPhoneTestResult> => {

  return customFetch<BulkPhoneTestResult>(getBulkTestPhonesUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getBulkTestPhonesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkTestPhones>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkTestPhones>>, TError,void, TContext> => {

const mutationKey = ['bulkTestPhones'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkTestPhones>>, void> = () => {


          return  bulkTestPhones(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkTestPhonesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkTestPhones>>>

    export type BulkTestPhonesMutationError = ErrorType<unknown>

    /**
 * @summary Queue throttled test SMS for all eligible automated-phone accounts
 */
export const useBulkTestPhones = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkTestPhones>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkTestPhones>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getBulkTestPhonesMutationOptions(options));
    }

export const getListAccountPhoneTestsUrl = (id: number,) => {




  return `/api/accounts/${id}/phone-tests`
}

/**
 * @summary List recent phone-test attempts for an account, most recent first
 */
export const listAccountPhoneTests = async (id: number, options?: RequestInit): Promise<PhoneTest[]> => {

  return customFetch<PhoneTest[]>(getListAccountPhoneTestsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountPhoneTestsQueryKey = (id: number,) => {
    return [
    `/api/accounts/${id}/phone-tests`
    ] as const;
    }


export const getListAccountPhoneTestsQueryOptions = <TData = Awaited<ReturnType<typeof listAccountPhoneTests>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountPhoneTests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountPhoneTestsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountPhoneTests>>> = ({ signal }) => listAccountPhoneTests(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountPhoneTests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountPhoneTestsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountPhoneTests>>>
export type ListAccountPhoneTestsQueryError = ErrorType<unknown>


/**
 * @summary List recent phone-test attempts for an account, most recent first
 */

export function useListAccountPhoneTests<TData = Awaited<ReturnType<typeof listAccountPhoneTests>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountPhoneTests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountPhoneTestsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListRecentPhoneTestsUrl = () => {




  return `/api/phone-tests/recent`
}

/**
 * @summary Recent phone-test attempts across all accounts plus bulk-run status
 */
export const listRecentPhoneTests = async ( options?: RequestInit): Promise<RecentPhoneTests> => {

  return customFetch<RecentPhoneTests>(getListRecentPhoneTestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecentPhoneTestsQueryKey = () => {
    return [
    `/api/phone-tests/recent`
    ] as const;
    }


export const getListRecentPhoneTestsQueryOptions = <TData = Awaited<ReturnType<typeof listRecentPhoneTests>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRecentPhoneTests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecentPhoneTestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecentPhoneTests>>> = ({ signal }) => listRecentPhoneTests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecentPhoneTests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRecentPhoneTestsQueryResult = NonNullable<Awaited<ReturnType<typeof listRecentPhoneTests>>>
export type ListRecentPhoneTestsQueryError = ErrorType<unknown>


/**
 * @summary Recent phone-test attempts across all accounts plus bulk-run status
 */

export function useListRecentPhoneTests<TData = Awaited<ReturnType<typeof listRecentPhoneTests>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRecentPhoneTests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRecentPhoneTestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListPhoneTypesUrl = () => {




  return `/api/phone-types`
}

/**
 * @summary List phone types with their automated/manual mode
 */
export const listPhoneTypes = async ( options?: RequestInit): Promise<PhoneTypeConfig[]> => {

  return customFetch<PhoneTypeConfig[]>(getListPhoneTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPhoneTypesQueryKey = () => {
    return [
    `/api/phone-types`
    ] as const;
    }


export const getListPhoneTypesQueryOptions = <TData = Awaited<ReturnType<typeof listPhoneTypes>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPhoneTypes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPhoneTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPhoneTypes>>> = ({ signal }) => listPhoneTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPhoneTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPhoneTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listPhoneTypes>>>
export type ListPhoneTypesQueryError = ErrorType<unknown>


/**
 * @summary List phone types with their automated/manual mode
 */

export function useListPhoneTypes<TData = Awaited<ReturnType<typeof listPhoneTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPhoneTypes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPhoneTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePhoneTypeUrl = () => {




  return `/api/phone-types`
}

/**
 * @summary Set a phone type's automated/manual mode
 */
export const updatePhoneType = async (phoneTypeUpdate: PhoneTypeUpdate, options?: RequestInit): Promise<PhoneTypeConfig> => {

  return customFetch<PhoneTypeConfig>(getUpdatePhoneTypeUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      phoneTypeUpdate,)
  }
);}




export const getUpdatePhoneTypeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePhoneType>>, TError,{data: BodyType<PhoneTypeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePhoneType>>, TError,{data: BodyType<PhoneTypeUpdate>}, TContext> => {

const mutationKey = ['updatePhoneType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePhoneType>>, {data: BodyType<PhoneTypeUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updatePhoneType(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePhoneTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updatePhoneType>>>
    export type UpdatePhoneTypeMutationBody = BodyType<PhoneTypeUpdate>
    export type UpdatePhoneTypeMutationError = ErrorType<unknown>

    /**
 * @summary Set a phone type's automated/manual mode
 */
export const useUpdatePhoneType = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePhoneType>>, TError,{data: BodyType<PhoneTypeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePhoneType>>,
        TError,
        {data: BodyType<PhoneTypeUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePhoneTypeMutationOptions(options));
    }

export const getListAccountVirtualBankAccountsUrl = (id: number,) => {




  return `/api/accounts/${id}/virtual-bank-accounts`
}

/**
 * @summary List virtual bank accounts for an account
 */
export const listAccountVirtualBankAccounts = async (id: number, options?: RequestInit): Promise<VirtualBankAccount[]> => {

  return customFetch<VirtualBankAccount[]>(getListAccountVirtualBankAccountsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountVirtualBankAccountsQueryKey = (id: number,) => {
    return [
    `/api/accounts/${id}/virtual-bank-accounts`
    ] as const;
    }


export const getListAccountVirtualBankAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listAccountVirtualBankAccounts>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountVirtualBankAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountVirtualBankAccountsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountVirtualBankAccounts>>> = ({ signal }) => listAccountVirtualBankAccounts(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountVirtualBankAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountVirtualBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountVirtualBankAccounts>>>
export type ListAccountVirtualBankAccountsQueryError = ErrorType<unknown>


/**
 * @summary List virtual bank accounts for an account
 */

export function useListAccountVirtualBankAccounts<TData = Awaited<ReturnType<typeof listAccountVirtualBankAccounts>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountVirtualBankAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountVirtualBankAccountsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateVirtualBankAccountUrl = (id: number,) => {




  return `/api/accounts/${id}/virtual-bank-accounts`
}

/**
 * @summary Add a manual virtual bank account
 */
export const createVirtualBankAccount = async (id: number,
    virtualBankAccountInput: VirtualBankAccountInput, options?: RequestInit): Promise<VirtualBankAccount> => {

  return customFetch<VirtualBankAccount>(getCreateVirtualBankAccountUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      virtualBankAccountInput,)
  }
);}




export const getCreateVirtualBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVirtualBankAccount>>, TError,{id: number;data: BodyType<VirtualBankAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVirtualBankAccount>>, TError,{id: number;data: BodyType<VirtualBankAccountInput>}, TContext> => {

const mutationKey = ['createVirtualBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVirtualBankAccount>>, {id: number;data: BodyType<VirtualBankAccountInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createVirtualBankAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVirtualBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createVirtualBankAccount>>>
    export type CreateVirtualBankAccountMutationBody = BodyType<VirtualBankAccountInput>
    export type CreateVirtualBankAccountMutationError = ErrorType<unknown>

    /**
 * @summary Add a manual virtual bank account
 */
export const useCreateVirtualBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVirtualBankAccount>>, TError,{id: number;data: BodyType<VirtualBankAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVirtualBankAccount>>,
        TError,
        {id: number;data: BodyType<VirtualBankAccountInput>},
        TContext
      > => {
      return useMutation(getCreateVirtualBankAccountMutationOptions(options));
    }

export const getUpdateVirtualBankAccountUrl = (id: number,) => {




  return `/api/virtual-bank-accounts/${id}`
}

/**
 * @summary Update a virtual bank account
 */
export const updateVirtualBankAccount = async (id: number,
    virtualBankAccountUpdate: VirtualBankAccountUpdate, options?: RequestInit): Promise<VirtualBankAccount> => {

  return customFetch<VirtualBankAccount>(getUpdateVirtualBankAccountUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      virtualBankAccountUpdate,)
  }
);}




export const getUpdateVirtualBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVirtualBankAccount>>, TError,{id: number;data: BodyType<VirtualBankAccountUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVirtualBankAccount>>, TError,{id: number;data: BodyType<VirtualBankAccountUpdate>}, TContext> => {

const mutationKey = ['updateVirtualBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVirtualBankAccount>>, {id: number;data: BodyType<VirtualBankAccountUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVirtualBankAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVirtualBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateVirtualBankAccount>>>
    export type UpdateVirtualBankAccountMutationBody = BodyType<VirtualBankAccountUpdate>
    export type UpdateVirtualBankAccountMutationError = ErrorType<unknown>

    /**
 * @summary Update a virtual bank account
 */
export const useUpdateVirtualBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVirtualBankAccount>>, TError,{id: number;data: BodyType<VirtualBankAccountUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVirtualBankAccount>>,
        TError,
        {id: number;data: BodyType<VirtualBankAccountUpdate>},
        TContext
      > => {
      return useMutation(getUpdateVirtualBankAccountMutationOptions(options));
    }

export const getListAccountMicroDepositsUrl = (id: number,) => {




  return `/api/accounts/${id}/micro-deposits`
}

/**
 * @summary Micro-deposit timeline for an account
 */
export const listAccountMicroDeposits = async (id: number, options?: RequestInit): Promise<MicroDeposit[]> => {

  return customFetch<MicroDeposit[]>(getListAccountMicroDepositsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountMicroDepositsQueryKey = (id: number,) => {
    return [
    `/api/accounts/${id}/micro-deposits`
    ] as const;
    }


export const getListAccountMicroDepositsQueryOptions = <TData = Awaited<ReturnType<typeof listAccountMicroDeposits>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountMicroDeposits>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountMicroDepositsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountMicroDeposits>>> = ({ signal }) => listAccountMicroDeposits(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountMicroDeposits>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountMicroDepositsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountMicroDeposits>>>
export type ListAccountMicroDepositsQueryError = ErrorType<unknown>


/**
 * @summary Micro-deposit timeline for an account
 */

export function useListAccountMicroDeposits<TData = Awaited<ReturnType<typeof listAccountMicroDeposits>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountMicroDeposits>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountMicroDepositsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMercuryAccountsUrl = () => {




  return `/api/mercury/accounts`
}

/**
 * @summary List Mercury accounts known to the app
 */
export const listMercuryAccounts = async ( options?: RequestInit): Promise<MercuryAccount[]> => {

  return customFetch<MercuryAccount[]>(getListMercuryAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMercuryAccountsQueryKey = () => {
    return [
    `/api/mercury/accounts`
    ] as const;
    }


export const getListMercuryAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listMercuryAccounts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMercuryAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMercuryAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMercuryAccounts>>> = ({ signal }) => listMercuryAccounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMercuryAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMercuryAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listMercuryAccounts>>>
export type ListMercuryAccountsQueryError = ErrorType<unknown>


/**
 * @summary List Mercury accounts known to the app
 */

export function useListMercuryAccounts<TData = Awaited<ReturnType<typeof listMercuryAccounts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMercuryAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMercuryAccountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSyncMercuryAccountsUrl = () => {




  return `/api/mercury/sync-accounts`
}

/**
 * @summary Sync the Mercury account list
 */
export const syncMercuryAccounts = async ( options?: RequestInit): Promise<IntegrationActionResult> => {

  return customFetch<IntegrationActionResult>(getSyncMercuryAccountsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSyncMercuryAccountsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncMercuryAccounts>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncMercuryAccounts>>, TError,void, TContext> => {

const mutationKey = ['syncMercuryAccounts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncMercuryAccounts>>, void> = () => {


          return  syncMercuryAccounts(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncMercuryAccountsMutationResult = NonNullable<Awaited<ReturnType<typeof syncMercuryAccounts>>>

    export type SyncMercuryAccountsMutationError = ErrorType<unknown>

    /**
 * @summary Sync the Mercury account list
 */
export const useSyncMercuryAccounts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncMercuryAccounts>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncMercuryAccounts>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncMercuryAccountsMutationOptions(options));
    }

export const getProvisionMercuryVirtualAccountUrl = () => {




  return `/api/mercury/virtual-accounts/provision`
}

/**
 * @summary Provision a Mercury virtual account (stub for future automation)
 */
export const provisionMercuryVirtualAccount = async (mercuryProvisionInput: MercuryProvisionInput, options?: RequestInit): Promise<IntegrationActionResult> => {

  return customFetch<IntegrationActionResult>(getProvisionMercuryVirtualAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mercuryProvisionInput,)
  }
);}




export const getProvisionMercuryVirtualAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionMercuryVirtualAccount>>, TError,{data: BodyType<MercuryProvisionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof provisionMercuryVirtualAccount>>, TError,{data: BodyType<MercuryProvisionInput>}, TContext> => {

const mutationKey = ['provisionMercuryVirtualAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof provisionMercuryVirtualAccount>>, {data: BodyType<MercuryProvisionInput>}> = (props) => {
          const {data} = props ?? {};

          return  provisionMercuryVirtualAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProvisionMercuryVirtualAccountMutationResult = NonNullable<Awaited<ReturnType<typeof provisionMercuryVirtualAccount>>>
    export type ProvisionMercuryVirtualAccountMutationBody = BodyType<MercuryProvisionInput>
    export type ProvisionMercuryVirtualAccountMutationError = ErrorType<unknown>

    /**
 * @summary Provision a Mercury virtual account (stub for future automation)
 */
export const useProvisionMercuryVirtualAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionMercuryVirtualAccount>>, TError,{data: BodyType<MercuryProvisionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof provisionMercuryVirtualAccount>>,
        TError,
        {data: BodyType<MercuryProvisionInput>},
        TContext
      > => {
      return useMutation(getProvisionMercuryVirtualAccountMutationOptions(options));
    }

export const getListPullersUrl = (params?: ListPullersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pullers?${stringifiedParams}` : `/api/pullers`
}

/**
 * @summary List AMP pullers
 */
export const listPullers = async (params?: ListPullersParams, options?: RequestInit): Promise<Puller[]> => {

  return customFetch<Puller[]>(getListPullersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPullersQueryKey = (params?: ListPullersParams,) => {
    return [
    `/api/pullers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPullersQueryOptions = <TData = Awaited<ReturnType<typeof listPullers>>, TError = ErrorType<unknown>>(params?: ListPullersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPullers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPullersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPullers>>> = ({ signal }) => listPullers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPullers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPullersQueryResult = NonNullable<Awaited<ReturnType<typeof listPullers>>>
export type ListPullersQueryError = ErrorType<unknown>


/**
 * @summary List AMP pullers
 */

export function useListPullers<TData = Awaited<ReturnType<typeof listPullers>>, TError = ErrorType<unknown>>(
 params?: ListPullersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPullers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPullersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetSettingsUrl = () => {




  return `/api/settings`
}

/**
 * @summary Get app settings and integration status
 */
export const getSettings = async ( options?: RequestInit): Promise<Settings> => {

  return customFetch<Settings>(getGetSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSettingsQueryKey = () => {
    return [
    `/api/settings`
    ] as const;
    }


export const getGetSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({ signal }) => getSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettings>>>
export type GetSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get app settings and integration status
 */

export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateSettingsUrl = () => {




  return `/api/settings`
}

/**
 * @summary Update app settings
 */
export const updateSettings = async (settingsUpdate: SettingsUpdate, options?: RequestInit): Promise<Settings> => {

  return customFetch<Settings>(getUpdateSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      settingsUpdate,)
  }
);}




export const getUpdateSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<SettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<SettingsUpdate>}, TContext> => {

const mutationKey = ['updateSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSettings>>, {data: BodyType<SettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSettings>>>
    export type UpdateSettingsMutationBody = BodyType<SettingsUpdate>
    export type UpdateSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update app settings
 */
export const useUpdateSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<SettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSettings>>,
        TError,
        {data: BodyType<SettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSettingsMutationOptions(options));
    }

export const getListUsersUrl = () => {




  return `/api/users`
}

/**
 * @summary List app users
 */
export const listUsers = async ( options?: RequestInit): Promise<AppUser[]> => {

  return customFetch<AppUser[]>(getListUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersQueryKey = () => {
    return [
    `/api/users`
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<unknown>


/**
 * @summary List app users
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateUserUrl = (id: number,) => {




  return `/api/users/${id}`
}

/**
 * @summary Update a user's role or linked puller
 */
export const updateUser = async (id: number,
    appUserUpdate: AppUserUpdate, options?: RequestInit): Promise<AppUser> => {

  return customFetch<AppUser>(getUpdateUserUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appUserUpdate,)
  }
);}




export const getUpdateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: number;data: BodyType<AppUserUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: number;data: BodyType<AppUserUpdate>}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {id: number;data: BodyType<AppUserUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUser(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = BodyType<AppUserUpdate>
    export type UpdateUserMutationError = ErrorType<unknown>

    /**
 * @summary Update a user's role or linked puller
 */
export const useUpdateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: number;data: BodyType<AppUserUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {id: number;data: BodyType<AppUserUpdate>},
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options));
    }

export const getListAuditLogUrl = (params?: ListAuditLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit-log?${stringifiedParams}` : `/api/audit-log`
}

/**
 * @summary Filtered, paginated audit log entries
 */
export const listAuditLog = async (params?: ListAuditLogParams, options?: RequestInit): Promise<AuditLogList> => {

  return customFetch<AuditLogList>(getListAuditLogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditLogQueryKey = (params?: ListAuditLogParams,) => {
    return [
    `/api/audit-log`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAuditLogQueryOptions = <TData = Awaited<ReturnType<typeof listAuditLog>>, TError = ErrorType<unknown>>(params?: ListAuditLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLog>>> = ({ signal }) => listAuditLog(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditLog>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAuditLogQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLog>>>
export type ListAuditLogQueryError = ErrorType<unknown>


/**
 * @summary Filtered, paginated audit log entries
 */

export function useListAuditLog<TData = Awaited<ReturnType<typeof listAuditLog>>, TError = ErrorType<unknown>>(
 params?: ListAuditLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAuditLogQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListRefreshRunsUrl = (params?: ListRefreshRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/refresh-runs?${stringifiedParams}` : `/api/refresh-runs`
}

/**
 * @summary Recent refresh runs
 */
export const listRefreshRuns = async (params?: ListRefreshRunsParams, options?: RequestInit): Promise<RefreshRun[]> => {

  return customFetch<RefreshRun[]>(getListRefreshRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRefreshRunsQueryKey = (params?: ListRefreshRunsParams,) => {
    return [
    `/api/refresh-runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRefreshRunsQueryOptions = <TData = Awaited<ReturnType<typeof listRefreshRuns>>, TError = ErrorType<unknown>>(params?: ListRefreshRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRefreshRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRefreshRunsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRefreshRuns>>> = ({ signal }) => listRefreshRuns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRefreshRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRefreshRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listRefreshRuns>>>
export type ListRefreshRunsQueryError = ErrorType<unknown>


/**
 * @summary Recent refresh runs
 */

export function useListRefreshRuns<TData = Awaited<ReturnType<typeof listRefreshRuns>>, TError = ErrorType<unknown>>(
 params?: ListRefreshRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRefreshRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRefreshRunsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getImportBankingUrl = () => {




  return `/api/banking/import`
}

/**
 * @summary Import bank accounts + mapping from CSV exports
 */
export const importBanking = async (bankImportRequest: BankImportRequest, options?: RequestInit): Promise<BankImportSummary> => {

  return customFetch<BankImportSummary>(getImportBankingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bankImportRequest,)
  }
);}




export const getImportBankingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importBanking>>, TError,{data: BodyType<BankImportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importBanking>>, TError,{data: BodyType<BankImportRequest>}, TContext> => {

const mutationKey = ['importBanking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importBanking>>, {data: BodyType<BankImportRequest>}> = (props) => {
          const {data} = props ?? {};

          return  importBanking(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportBankingMutationResult = NonNullable<Awaited<ReturnType<typeof importBanking>>>
    export type ImportBankingMutationBody = BodyType<BankImportRequest>
    export type ImportBankingMutationError = ErrorType<unknown>

    /**
 * @summary Import bank accounts + mapping from CSV exports
 */
export const useImportBanking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importBanking>>, TError,{data: BodyType<BankImportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importBanking>>,
        TError,
        {data: BodyType<BankImportRequest>},
        TContext
      > => {
      return useMutation(getImportBankingMutationOptions(options));
    }

export const getListBankAccountsUrl = (params?: ListBankAccountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/banking/bank-accounts?${stringifiedParams}` : `/api/banking/bank-accounts`
}

/**
 * @summary List physical bank accounts (masked)
 */
export const listBankAccounts = async (params?: ListBankAccountsParams, options?: RequestInit): Promise<BankAccount[]> => {

  return customFetch<BankAccount[]>(getListBankAccountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBankAccountsQueryKey = (params?: ListBankAccountsParams,) => {
    return [
    `/api/banking/bank-accounts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBankAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listBankAccounts>>, TError = ErrorType<unknown>>(params?: ListBankAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBankAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBankAccounts>>> = ({ signal }) => listBankAccounts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listBankAccounts>>>
export type ListBankAccountsQueryError = ErrorType<unknown>


/**
 * @summary List physical bank accounts (masked)
 */

export function useListBankAccounts<TData = Awaited<ReturnType<typeof listBankAccounts>>, TError = ErrorType<unknown>>(
 params?: ListBankAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBankAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBankAccountUrl = () => {




  return `/api/banking/bank-accounts`
}

/**
 * @summary Manually add a bank account and auto-create its open slots
 */
export const createBankAccount = async (bankAccountCreate: BankAccountCreate, options?: RequestInit): Promise<BankAccount> => {

  return customFetch<BankAccount>(getCreateBankAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bankAccountCreate,)
  }
);}




export const getCreateBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankAccount>>, TError,{data: BodyType<BankAccountCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBankAccount>>, TError,{data: BodyType<BankAccountCreate>}, TContext> => {

const mutationKey = ['createBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBankAccount>>, {data: BodyType<BankAccountCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createBankAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createBankAccount>>>
    export type CreateBankAccountMutationBody = BodyType<BankAccountCreate>
    export type CreateBankAccountMutationError = ErrorType<unknown>

    /**
 * @summary Manually add a bank account and auto-create its open slots
 */
export const useCreateBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankAccount>>, TError,{data: BodyType<BankAccountCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBankAccount>>,
        TError,
        {data: BodyType<BankAccountCreate>},
        TContext
      > => {
      return useMutation(getCreateBankAccountMutationOptions(options));
    }

export const getListBankAccountMappingUrl = (params?: ListBankAccountMappingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/banking/bank-account-mapping?${stringifiedParams}` : `/api/banking/bank-account-mapping`
}

/**
 * @summary List variant allocation slots
 */
export const listBankAccountMapping = async (params?: ListBankAccountMappingParams, options?: RequestInit): Promise<BankVariant[]> => {

  return customFetch<BankVariant[]>(getListBankAccountMappingUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBankAccountMappingQueryKey = (params?: ListBankAccountMappingParams,) => {
    return [
    `/api/banking/bank-account-mapping`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBankAccountMappingQueryOptions = <TData = Awaited<ReturnType<typeof listBankAccountMapping>>, TError = ErrorType<unknown>>(params?: ListBankAccountMappingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankAccountMapping>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBankAccountMappingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBankAccountMapping>>> = ({ signal }) => listBankAccountMapping(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBankAccountMapping>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBankAccountMappingQueryResult = NonNullable<Awaited<ReturnType<typeof listBankAccountMapping>>>
export type ListBankAccountMappingQueryError = ErrorType<unknown>


/**
 * @summary List variant allocation slots
 */

export function useListBankAccountMapping<TData = Awaited<ReturnType<typeof listBankAccountMapping>>, TError = ErrorType<unknown>>(
 params?: ListBankAccountMappingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankAccountMapping>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBankAccountMappingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAssignBankSlotUrl = () => {




  return `/api/banking/assign`
}

/**
 * @summary Auto-assign an open slot to an inventory account email
 */
export const assignBankSlot = async (assignSlotRequest: AssignSlotRequest, options?: RequestInit): Promise<AssignSlotResult> => {

  return customFetch<AssignSlotResult>(getAssignBankSlotUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      assignSlotRequest,)
  }
);}




export const getAssignBankSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignBankSlot>>, TError,{data: BodyType<AssignSlotRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignBankSlot>>, TError,{data: BodyType<AssignSlotRequest>}, TContext> => {

const mutationKey = ['assignBankSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignBankSlot>>, {data: BodyType<AssignSlotRequest>}> = (props) => {
          const {data} = props ?? {};

          return  assignBankSlot(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignBankSlotMutationResult = NonNullable<Awaited<ReturnType<typeof assignBankSlot>>>
    export type AssignBankSlotMutationBody = BodyType<AssignSlotRequest>
    export type AssignBankSlotMutationError = ErrorType<unknown>

    /**
 * @summary Auto-assign an open slot to an inventory account email
 */
export const useAssignBankSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignBankSlot>>, TError,{data: BodyType<AssignSlotRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignBankSlot>>,
        TError,
        {data: BodyType<AssignSlotRequest>},
        TContext
      > => {
      return useMutation(getAssignBankSlotMutationOptions(options));
    }

export const getUnassignBankSlotUrl = (id: number,) => {




  return `/api/banking/bank-account-mapping/${id}/unassign`
}

/**
 * @summary Release a slot back to the available pool
 */
export const unassignBankSlot = async (id: number, options?: RequestInit): Promise<BankVariant> => {

  return customFetch<BankVariant>(getUnassignBankSlotUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnassignBankSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignBankSlot>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unassignBankSlot>>, TError,{id: number}, TContext> => {

const mutationKey = ['unassignBankSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unassignBankSlot>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  unassignBankSlot(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnassignBankSlotMutationResult = NonNullable<Awaited<ReturnType<typeof unassignBankSlot>>>

    export type UnassignBankSlotMutationError = ErrorType<unknown>

    /**
 * @summary Release a slot back to the available pool
 */
export const useUnassignBankSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignBankSlot>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unassignBankSlot>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getUnassignBankSlotMutationOptions(options));
    }

export const getBurnBankVariantUrl = (variantId: number,) => {




  return `/api/banking/variants/${variantId}/burn`
}

/**
 * @summary Burn (retire) a variant slot and auto-assign a replacement
 */
export const burnBankVariant = async (variantId: number, options?: RequestInit): Promise<BurnSlotResult> => {

  return customFetch<BurnSlotResult>(getBurnBankVariantUrl(variantId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getBurnBankVariantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof burnBankVariant>>, TError,{variantId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof burnBankVariant>>, TError,{variantId: number}, TContext> => {

const mutationKey = ['burnBankVariant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof burnBankVariant>>, {variantId: number}> = (props) => {
          const {variantId} = props ?? {};

          return  burnBankVariant(variantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BurnBankVariantMutationResult = NonNullable<Awaited<ReturnType<typeof burnBankVariant>>>

    export type BurnBankVariantMutationError = ErrorType<unknown>

    /**
 * @summary Burn (retire) a variant slot and auto-assign a replacement
 */
export const useBurnBankVariant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof burnBankVariant>>, TError,{variantId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof burnBankVariant>>,
        TError,
        {variantId: number},
        TContext
      > => {
      return useMutation(getBurnBankVariantMutationOptions(options));
    }

export const getResolveBanksUrl = (params: ResolveBanksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/banking/resolve?${stringifiedParams}` : `/api/banking/resolve`
}

/**
 * @summary Resolve bank data for one or more inventory account emails
 */
export const resolveBanks = async (params: ResolveBanksParams, options?: RequestInit): Promise<ResolvedBank[]> => {

  return customFetch<ResolvedBank[]>(getResolveBanksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getResolveBanksQueryKey = (params?: ResolveBanksParams,) => {
    return [
    `/api/banking/resolve`, ...(params ? [params] : [])
    ] as const;
    }


export const getResolveBanksQueryOptions = <TData = Awaited<ReturnType<typeof resolveBanks>>, TError = ErrorType<unknown>>(params: ResolveBanksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof resolveBanks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolveBanksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveBanks>>> = ({ signal }) => resolveBanks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resolveBanks>>, TError, TData> & { queryKey: QueryKey }
}

export type ResolveBanksQueryResult = NonNullable<Awaited<ReturnType<typeof resolveBanks>>>
export type ResolveBanksQueryError = ErrorType<unknown>


/**
 * @summary Resolve bank data for one or more inventory account emails
 */

export function useResolveBanks<TData = Awaited<ReturnType<typeof resolveBanks>>, TError = ErrorType<unknown>>(
 params: ResolveBanksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof resolveBanks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getResolveBanksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListBankingSourcesUrl = () => {




  return `/api/banking/sources`
}

/**
 * @summary List configurable banking sources
 */
export const listBankingSources = async ( options?: RequestInit): Promise<BankingSource[]> => {

  return customFetch<BankingSource[]>(getListBankingSourcesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBankingSourcesQueryKey = () => {
    return [
    `/api/banking/sources`
    ] as const;
    }


export const getListBankingSourcesQueryOptions = <TData = Awaited<ReturnType<typeof listBankingSources>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankingSources>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBankingSourcesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBankingSources>>> = ({ signal }) => listBankingSources({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBankingSources>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBankingSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof listBankingSources>>>
export type ListBankingSourcesQueryError = ErrorType<unknown>


/**
 * @summary List configurable banking sources
 */

export function useListBankingSources<TData = Awaited<ReturnType<typeof listBankingSources>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankingSources>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBankingSourcesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBankingSourceUrl = () => {




  return `/api/banking/sources`
}

/**
 * @summary Create a banking source
 */
export const createBankingSource = async (bankingSourceInput: BankingSourceInput, options?: RequestInit): Promise<BankingSource> => {

  return customFetch<BankingSource>(getCreateBankingSourceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bankingSourceInput,)
  }
);}




export const getCreateBankingSourceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankingSource>>, TError,{data: BodyType<BankingSourceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBankingSource>>, TError,{data: BodyType<BankingSourceInput>}, TContext> => {

const mutationKey = ['createBankingSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBankingSource>>, {data: BodyType<BankingSourceInput>}> = (props) => {
          const {data} = props ?? {};

          return  createBankingSource(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBankingSourceMutationResult = NonNullable<Awaited<ReturnType<typeof createBankingSource>>>
    export type CreateBankingSourceMutationBody = BodyType<BankingSourceInput>
    export type CreateBankingSourceMutationError = ErrorType<unknown>

    /**
 * @summary Create a banking source
 */
export const useCreateBankingSource = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankingSource>>, TError,{data: BodyType<BankingSourceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBankingSource>>,
        TError,
        {data: BodyType<BankingSourceInput>},
        TContext
      > => {
      return useMutation(getCreateBankingSourceMutationOptions(options));
    }

export const getUpdateBankingSourceUrl = (id: number,) => {




  return `/api/banking/sources/${id}`
}

/**
 * @summary Update a banking source
 */
export const updateBankingSource = async (id: number,
    bankingSourceUpdate: BankingSourceUpdate, options?: RequestInit): Promise<BankingSource> => {

  return customFetch<BankingSource>(getUpdateBankingSourceUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bankingSourceUpdate,)
  }
);}




export const getUpdateBankingSourceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBankingSource>>, TError,{id: number;data: BodyType<BankingSourceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBankingSource>>, TError,{id: number;data: BodyType<BankingSourceUpdate>}, TContext> => {

const mutationKey = ['updateBankingSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBankingSource>>, {id: number;data: BodyType<BankingSourceUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBankingSource(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBankingSourceMutationResult = NonNullable<Awaited<ReturnType<typeof updateBankingSource>>>
    export type UpdateBankingSourceMutationBody = BodyType<BankingSourceUpdate>
    export type UpdateBankingSourceMutationError = ErrorType<unknown>

    /**
 * @summary Update a banking source
 */
export const useUpdateBankingSource = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBankingSource>>, TError,{id: number;data: BodyType<BankingSourceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBankingSource>>,
        TError,
        {id: number;data: BodyType<BankingSourceUpdate>},
        TContext
      > => {
      return useMutation(getUpdateBankingSourceMutationOptions(options));
    }

export const getGetAccountBankHistoryUrl = (params: GetAccountBankHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/banking/account-history?${stringifiedParams}` : `/api/banking/account-history`
}

/**
 * @summary Bank-swap history for one inventory account (incl. burn re-homes)
 */
export const getAccountBankHistory = async (params: GetAccountBankHistoryParams, options?: RequestInit): Promise<BankSwapHistoryEntry[]> => {

  return customFetch<BankSwapHistoryEntry[]>(getGetAccountBankHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountBankHistoryQueryKey = (params?: GetAccountBankHistoryParams,) => {
    return [
    `/api/banking/account-history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAccountBankHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getAccountBankHistory>>, TError = ErrorType<unknown>>(params: GetAccountBankHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountBankHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountBankHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountBankHistory>>> = ({ signal }) => getAccountBankHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountBankHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountBankHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountBankHistory>>>
export type GetAccountBankHistoryQueryError = ErrorType<unknown>


/**
 * @summary Bank-swap history for one inventory account (incl. burn re-homes)
 */

export function useGetAccountBankHistory<TData = Awaited<ReturnType<typeof getAccountBankHistory>>, TError = ErrorType<unknown>>(
 params: GetAccountBankHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountBankHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountBankHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListBankingAuditUrl = (params?: ListBankingAuditParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/banking/audit?${stringifiedParams}` : `/api/banking/audit`
}

/**
 * @summary Recent banking audit entries
 */
export const listBankingAudit = async (params?: ListBankingAuditParams, options?: RequestInit): Promise<BankingAuditEntry[]> => {

  return customFetch<BankingAuditEntry[]>(getListBankingAuditUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBankingAuditQueryKey = (params?: ListBankingAuditParams,) => {
    return [
    `/api/banking/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBankingAuditQueryOptions = <TData = Awaited<ReturnType<typeof listBankingAudit>>, TError = ErrorType<unknown>>(params?: ListBankingAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankingAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBankingAuditQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBankingAudit>>> = ({ signal }) => listBankingAudit(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBankingAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBankingAuditQueryResult = NonNullable<Awaited<ReturnType<typeof listBankingAudit>>>
export type ListBankingAuditQueryError = ErrorType<unknown>


/**
 * @summary Recent banking audit entries
 */

export function useListBankingAudit<TData = Awaited<ReturnType<typeof listBankingAudit>>, TError = ErrorType<unknown>>(
 params?: ListBankingAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankingAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBankingAuditQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListSalesUrl = (params?: ListSalesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sales?${stringifiedParams}` : `/api/sales`
}

/**
 * @summary Confirmed sale-confirmation rows, one per sale, listing-centric
 */
export const listSales = async (params?: ListSalesParams, options?: RequestInit): Promise<SalesList> => {

  return customFetch<SalesList>(getListSalesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalesQueryKey = (params?: ListSalesParams,) => {
    return [
    `/api/sales`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSalesQueryOptions = <TData = Awaited<ReturnType<typeof listSales>>, TError = ErrorType<unknown>>(params?: ListSalesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSales>>> = ({ signal }) => listSales(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSales>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalesQueryResult = NonNullable<Awaited<ReturnType<typeof listSales>>>
export type ListSalesQueryError = ErrorType<unknown>


/**
 * @summary Confirmed sale-confirmation rows, one per sale, listing-centric
 */

export function useListSales<TData = Awaited<ReturnType<typeof listSales>>, TError = ErrorType<unknown>>(
 params?: ListSalesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetSalesSyncStatusUrl = () => {




  return `/api/sales/sync-status`
}

/**
 * @summary Last/next scheduled sales-sync time and whether it is enabled
 */
export const getSalesSyncStatus = async ( options?: RequestInit): Promise<SalesSyncStatus> => {

  return customFetch<SalesSyncStatus>(getGetSalesSyncStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSalesSyncStatusQueryKey = () => {
    return [
    `/api/sales/sync-status`
    ] as const;
    }


export const getGetSalesSyncStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSalesSyncStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesSyncStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesSyncStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesSyncStatus>>> = ({ signal }) => getSalesSyncStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesSyncStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesSyncStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesSyncStatus>>>
export type GetSalesSyncStatusQueryError = ErrorType<unknown>


/**
 * @summary Last/next scheduled sales-sync time and whether it is enabled
 */

export function useGetSalesSyncStatus<TData = Awaited<ReturnType<typeof getSalesSyncStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesSyncStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesSyncStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPushSaleToReachUrl = (saleEmailId: number,) => {




  return `/api/sales/${saleEmailId}/push-to-reach`
}

/**
 * @summary Push a not-yet-in-Reach sale to Reach (stubbed write until configured)
 */
export const pushSaleToReach = async (saleEmailId: number, options?: RequestInit): Promise<PushToReachResult> => {

  return customFetch<PushToReachResult>(getPushSaleToReachUrl(saleEmailId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPushSaleToReachMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushSaleToReach>>, TError,{saleEmailId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushSaleToReach>>, TError,{saleEmailId: number}, TContext> => {

const mutationKey = ['pushSaleToReach'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushSaleToReach>>, {saleEmailId: number}> = (props) => {
          const {saleEmailId} = props ?? {};

          return  pushSaleToReach(saleEmailId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushSaleToReachMutationResult = NonNullable<Awaited<ReturnType<typeof pushSaleToReach>>>

    export type PushSaleToReachMutationError = ErrorType<unknown>

    /**
 * @summary Push a not-yet-in-Reach sale to Reach (stubbed write until configured)
 */
export const usePushSaleToReach = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushSaleToReach>>, TError,{saleEmailId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pushSaleToReach>>,
        TError,
        {saleEmailId: number},
        TContext
      > => {
      return useMutation(getPushSaleToReachMutationOptions(options));
    }

export const getSyncSalesUrl = () => {




  return `/api/emails/sync`
}

/**
 * @summary Pull and reconcile Ticketmaster sale emails from BigQuery
 */
export const syncSales = async (syncSalesRequest?: SyncSalesRequest, options?: RequestInit): Promise<SyncSalesSummary> => {

  return customFetch<SyncSalesSummary>(getSyncSalesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      syncSalesRequest,)
  }
);}




export const getSyncSalesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSales>>, TError,{data?: BodyType<SyncSalesRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncSales>>, TError,{data?: BodyType<SyncSalesRequest>}, TContext> => {

const mutationKey = ['syncSales'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncSales>>, {data?: BodyType<SyncSalesRequest>}> = (props) => {
          const {data} = props ?? {};

          return  syncSales(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncSalesMutationResult = NonNullable<Awaited<ReturnType<typeof syncSales>>>
    export type SyncSalesMutationBody = BodyType<SyncSalesRequest> | undefined
    export type SyncSalesMutationError = ErrorType<unknown>

    /**
 * @summary Pull and reconcile Ticketmaster sale emails from BigQuery
 */
export const useSyncSales = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSales>>, TError,{data?: BodyType<SyncSalesRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncSales>>,
        TError,
        {data?: BodyType<SyncSalesRequest>},
        TContext
      > => {
      return useMutation(getSyncSalesMutationOptions(options));
    }

export const getGetSalesStatusUrl = () => {




  return `/api/emails/status`
}

/**
 * @summary Sales tab configuration and per-filter counts
 */
export const getSalesStatus = async ( options?: RequestInit): Promise<SalesStatus> => {

  return customFetch<SalesStatus>(getGetSalesStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSalesStatusQueryKey = () => {
    return [
    `/api/emails/status`
    ] as const;
    }


export const getGetSalesStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSalesStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesStatus>>> = ({ signal }) => getSalesStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesStatus>>>
export type GetSalesStatusQueryError = ErrorType<unknown>


/**
 * @summary Sales tab configuration and per-filter counts
 */

export function useGetSalesStatus<TData = Awaited<ReturnType<typeof getSalesStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListSaleEmailsUrl = (params?: ListSaleEmailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/emails?${stringifiedParams}` : `/api/emails`
}

/**
 * @summary List parsed sale emails with their match state
 */
export const listSaleEmails = async (params?: ListSaleEmailsParams, options?: RequestInit): Promise<SaleEmailList> => {

  return customFetch<SaleEmailList>(getListSaleEmailsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSaleEmailsQueryKey = (params?: ListSaleEmailsParams,) => {
    return [
    `/api/emails`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSaleEmailsQueryOptions = <TData = Awaited<ReturnType<typeof listSaleEmails>>, TError = ErrorType<unknown>>(params?: ListSaleEmailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSaleEmails>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSaleEmailsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSaleEmails>>> = ({ signal }) => listSaleEmails(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSaleEmails>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSaleEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof listSaleEmails>>>
export type ListSaleEmailsQueryError = ErrorType<unknown>


/**
 * @summary List parsed sale emails with their match state
 */

export function useListSaleEmails<TData = Awaited<ReturnType<typeof listSaleEmails>>, TError = ErrorType<unknown>>(
 params?: ListSaleEmailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSaleEmails>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSaleEmailsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetSaleEmailUrl = (id: number,) => {




  return `/api/emails/${id}`
}

/**
 * @summary Sale email detail with candidates and Reach invoice
 */
export const getSaleEmail = async (id: number, options?: RequestInit): Promise<SaleEmailDetail> => {

  return customFetch<SaleEmailDetail>(getGetSaleEmailUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSaleEmailQueryKey = (id: number,) => {
    return [
    `/api/emails/${id}`
    ] as const;
    }


export const getGetSaleEmailQueryOptions = <TData = Awaited<ReturnType<typeof getSaleEmail>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSaleEmail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSaleEmailQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSaleEmail>>> = ({ signal }) => getSaleEmail(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSaleEmail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSaleEmailQueryResult = NonNullable<Awaited<ReturnType<typeof getSaleEmail>>>
export type GetSaleEmailQueryError = ErrorType<unknown>


/**
 * @summary Sale email detail with candidates and Reach invoice
 */

export function useGetSaleEmail<TData = Awaited<ReturnType<typeof getSaleEmail>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSaleEmail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSaleEmailQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getResyncSaleEmailsUrl = () => {




  return `/api/emails/resync`
}

/**
 * @summary Bulk re-parse and/or re-match stored sale emails
 */
export const resyncSaleEmails = async (resyncSaleEmailsRequest?: ResyncSaleEmailsRequest, options?: RequestInit): Promise<ResyncSaleEmailsResult> => {

  return customFetch<ResyncSaleEmailsResult>(getResyncSaleEmailsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resyncSaleEmailsRequest,)
  }
);}




export const getResyncSaleEmailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resyncSaleEmails>>, TError,{data?: BodyType<ResyncSaleEmailsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resyncSaleEmails>>, TError,{data?: BodyType<ResyncSaleEmailsRequest>}, TContext> => {

const mutationKey = ['resyncSaleEmails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resyncSaleEmails>>, {data?: BodyType<ResyncSaleEmailsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  resyncSaleEmails(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResyncSaleEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof resyncSaleEmails>>>
    export type ResyncSaleEmailsMutationBody = BodyType<ResyncSaleEmailsRequest> | undefined
    export type ResyncSaleEmailsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk re-parse and/or re-match stored sale emails
 */
export const useResyncSaleEmails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resyncSaleEmails>>, TError,{data?: BodyType<ResyncSaleEmailsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resyncSaleEmails>>,
        TError,
        {data?: BodyType<ResyncSaleEmailsRequest>},
        TContext
      > => {
      return useMutation(getResyncSaleEmailsMutationOptions(options));
    }

export const getRematchSalesEmailsUrl = () => {




  return `/api/emails/rematch`
}

/**
 * Re-runs the sale matcher across every already-stored sale email in memory (no BigQuery fetch, no DB writes) and returns the inventory rows whose Sold status or sold ticket count would change, for operator review.
 * @summary Dry-run a bulk rematch over stored sale emails (no writes)
 */
export const rematchSalesEmails = async ( options?: RequestInit): Promise<RematchSalesDiff> => {

  return customFetch<RematchSalesDiff>(getRematchSalesEmailsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRematchSalesEmailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rematchSalesEmails>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rematchSalesEmails>>, TError,void, TContext> => {

const mutationKey = ['rematchSalesEmails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rematchSalesEmails>>, void> = () => {


          return  rematchSalesEmails(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RematchSalesEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof rematchSalesEmails>>>

    export type RematchSalesEmailsMutationError = ErrorType<unknown>

    /**
 * @summary Dry-run a bulk rematch over stored sale emails (no writes)
 */
export const useRematchSalesEmails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rematchSalesEmails>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rematchSalesEmails>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRematchSalesEmailsMutationOptions(options));
    }

export const getApplyRematchSalesEmailsUrl = () => {




  return `/api/emails/rematch/apply`
}

/**
 * @summary Apply a bulk rematch for the operator-approved inventory rows
 */
export const applyRematchSalesEmails = async (rematchSalesApplyRequest: RematchSalesApplyRequest, options?: RequestInit): Promise<RematchSalesApplyResult> => {

  return customFetch<RematchSalesApplyResult>(getApplyRematchSalesEmailsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rematchSalesApplyRequest,)
  }
);}




export const getApplyRematchSalesEmailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyRematchSalesEmails>>, TError,{data: BodyType<RematchSalesApplyRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyRematchSalesEmails>>, TError,{data: BodyType<RematchSalesApplyRequest>}, TContext> => {

const mutationKey = ['applyRematchSalesEmails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyRematchSalesEmails>>, {data: BodyType<RematchSalesApplyRequest>}> = (props) => {
          const {data} = props ?? {};

          return  applyRematchSalesEmails(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyRematchSalesEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof applyRematchSalesEmails>>>
    export type ApplyRematchSalesEmailsMutationBody = BodyType<RematchSalesApplyRequest>
    export type ApplyRematchSalesEmailsMutationError = ErrorType<unknown>

    /**
 * @summary Apply a bulk rematch for the operator-approved inventory rows
 */
export const useApplyRematchSalesEmails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyRematchSalesEmails>>, TError,{data: BodyType<RematchSalesApplyRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof applyRematchSalesEmails>>,
        TError,
        {data: BodyType<RematchSalesApplyRequest>},
        TContext
      > => {
      return useMutation(getApplyRematchSalesEmailsMutationOptions(options));
    }

export const getRematchSaleEmailUrl = (id: number,) => {




  return `/api/emails/${id}/rematch`
}

/**
 * @summary Re-run parsing and/or matching for a single email
 */
export const rematchSaleEmail = async (id: number,
    rematchSaleEmailRequest?: RematchSaleEmailRequest, options?: RequestInit): Promise<SaleEmailRow> => {

  return customFetch<SaleEmailRow>(getRematchSaleEmailUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rematchSaleEmailRequest,)
  }
);}




export const getRematchSaleEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rematchSaleEmail>>, TError,{id: number;data?: BodyType<RematchSaleEmailRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rematchSaleEmail>>, TError,{id: number;data?: BodyType<RematchSaleEmailRequest>}, TContext> => {

const mutationKey = ['rematchSaleEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rematchSaleEmail>>, {id: number;data?: BodyType<RematchSaleEmailRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  rematchSaleEmail(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RematchSaleEmailMutationResult = NonNullable<Awaited<ReturnType<typeof rematchSaleEmail>>>
    export type RematchSaleEmailMutationBody = BodyType<RematchSaleEmailRequest> | undefined
    export type RematchSaleEmailMutationError = ErrorType<unknown>

    /**
 * @summary Re-run parsing and/or matching for a single email
 */
export const useRematchSaleEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rematchSaleEmail>>, TError,{id: number;data?: BodyType<RematchSaleEmailRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rematchSaleEmail>>,
        TError,
        {id: number;data?: BodyType<RematchSaleEmailRequest>},
        TContext
      > => {
      return useMutation(getRematchSaleEmailMutationOptions(options));
    }

export const getUnlinkSaleEmailUrl = (id: number,) => {




  return `/api/emails/${id}/unlink`
}

/**
 * @summary Clear a sale email's inventory match (returns it to unmatched)
 */
export const unlinkSaleEmail = async (id: number, options?: RequestInit): Promise<SaleEmailRow> => {

  return customFetch<SaleEmailRow>(getUnlinkSaleEmailUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnlinkSaleEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkSaleEmail>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlinkSaleEmail>>, TError,{id: number}, TContext> => {

const mutationKey = ['unlinkSaleEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkSaleEmail>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  unlinkSaleEmail(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkSaleEmailMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkSaleEmail>>>

    export type UnlinkSaleEmailMutationError = ErrorType<unknown>

    /**
 * @summary Clear a sale email's inventory match (returns it to unmatched)
 */
export const useUnlinkSaleEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkSaleEmail>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unlinkSaleEmail>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getUnlinkSaleEmailMutationOptions(options));
    }

export const getManualMatchSaleEmailUrl = (id: number,) => {




  return `/api/emails/${id}/manual-match`
}

/**
 * @summary Manually attach an inventory row to a sale email
 */
export const manualMatchSaleEmail = async (id: number,
    manualMatchRequest: ManualMatchRequest, options?: RequestInit): Promise<SaleEmailRow> => {

  return customFetch<SaleEmailRow>(getManualMatchSaleEmailUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      manualMatchRequest,)
  }
);}




export const getManualMatchSaleEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof manualMatchSaleEmail>>, TError,{id: number;data: BodyType<ManualMatchRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof manualMatchSaleEmail>>, TError,{id: number;data: BodyType<ManualMatchRequest>}, TContext> => {

const mutationKey = ['manualMatchSaleEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof manualMatchSaleEmail>>, {id: number;data: BodyType<ManualMatchRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  manualMatchSaleEmail(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ManualMatchSaleEmailMutationResult = NonNullable<Awaited<ReturnType<typeof manualMatchSaleEmail>>>
    export type ManualMatchSaleEmailMutationBody = BodyType<ManualMatchRequest>
    export type ManualMatchSaleEmailMutationError = ErrorType<unknown>

    /**
 * @summary Manually attach an inventory row to a sale email
 */
export const useManualMatchSaleEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof manualMatchSaleEmail>>, TError,{id: number;data: BodyType<ManualMatchRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof manualMatchSaleEmail>>,
        TError,
        {id: number;data: BodyType<ManualMatchRequest>},
        TContext
      > => {
      return useMutation(getManualMatchSaleEmailMutationOptions(options));
    }

export const getReviewSaleEmailUrl = (id: number,) => {




  return `/api/emails/${id}/mark-reviewed`
}

/**
 * @summary Mark a sale email reviewed and optionally add notes
 */
export const reviewSaleEmail = async (id: number,
    reviewSaleEmailRequest?: ReviewSaleEmailRequest, options?: RequestInit): Promise<SaleEmailRow> => {

  return customFetch<SaleEmailRow>(getReviewSaleEmailUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reviewSaleEmailRequest,)
  }
);}




export const getReviewSaleEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewSaleEmail>>, TError,{id: number;data?: BodyType<ReviewSaleEmailRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewSaleEmail>>, TError,{id: number;data?: BodyType<ReviewSaleEmailRequest>}, TContext> => {

const mutationKey = ['reviewSaleEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewSaleEmail>>, {id: number;data?: BodyType<ReviewSaleEmailRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  reviewSaleEmail(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewSaleEmailMutationResult = NonNullable<Awaited<ReturnType<typeof reviewSaleEmail>>>
    export type ReviewSaleEmailMutationBody = BodyType<ReviewSaleEmailRequest> | undefined
    export type ReviewSaleEmailMutationError = ErrorType<unknown>

    /**
 * @summary Mark a sale email reviewed and optionally add notes
 */
export const useReviewSaleEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewSaleEmail>>, TError,{id: number;data?: BodyType<ReviewSaleEmailRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviewSaleEmail>>,
        TError,
        {id: number;data?: BodyType<ReviewSaleEmailRequest>},
        TContext
      > => {
      return useMutation(getReviewSaleEmailMutationOptions(options));
    }

export const getIgnoreSaleEmailUrl = (id: number,) => {




  return `/api/emails/${id}/ignore`
}

/**
 * @summary Mark a sale email as ignored (or restore it)
 */
export const ignoreSaleEmail = async (id: number,
    ignoreSaleEmailRequest?: IgnoreSaleEmailRequest, options?: RequestInit): Promise<SaleEmailRow> => {

  return customFetch<SaleEmailRow>(getIgnoreSaleEmailUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ignoreSaleEmailRequest,)
  }
);}




export const getIgnoreSaleEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ignoreSaleEmail>>, TError,{id: number;data?: BodyType<IgnoreSaleEmailRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof ignoreSaleEmail>>, TError,{id: number;data?: BodyType<IgnoreSaleEmailRequest>}, TContext> => {

const mutationKey = ['ignoreSaleEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ignoreSaleEmail>>, {id: number;data?: BodyType<IgnoreSaleEmailRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  ignoreSaleEmail(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IgnoreSaleEmailMutationResult = NonNullable<Awaited<ReturnType<typeof ignoreSaleEmail>>>
    export type IgnoreSaleEmailMutationBody = BodyType<IgnoreSaleEmailRequest> | undefined
    export type IgnoreSaleEmailMutationError = ErrorType<unknown>

    /**
 * @summary Mark a sale email as ignored (or restore it)
 */
export const useIgnoreSaleEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ignoreSaleEmail>>, TError,{id: number;data?: BodyType<IgnoreSaleEmailRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof ignoreSaleEmail>>,
        TError,
        {id: number;data?: BodyType<IgnoreSaleEmailRequest>},
        TContext
      > => {
      return useMutation(getIgnoreSaleEmailMutationOptions(options));
    }

export const getListSlackChannelsUrl = () => {




  return `/api/slack/channels`
}

/**
 * @summary List Slack channels the bot can reach
 */
export const listSlackChannels = async ( options?: RequestInit): Promise<SlackChannel[]> => {

  return customFetch<SlackChannel[]>(getListSlackChannelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSlackChannelsQueryKey = () => {
    return [
    `/api/slack/channels`
    ] as const;
    }


export const getListSlackChannelsQueryOptions = <TData = Awaited<ReturnType<typeof listSlackChannels>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSlackChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSlackChannelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSlackChannels>>> = ({ signal }) => listSlackChannels({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSlackChannels>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSlackChannelsQueryResult = NonNullable<Awaited<ReturnType<typeof listSlackChannels>>>
export type ListSlackChannelsQueryError = ErrorType<unknown>


/**
 * @summary List Slack channels the bot can reach
 */

export function useListSlackChannels<TData = Awaited<ReturnType<typeof listSlackChannels>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSlackChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSlackChannelsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListSlackUsersUrl = () => {




  return `/api/slack/users`
}

/**
 * @summary List Slack workspace members
 */
export const listSlackUsers = async ( options?: RequestInit): Promise<SlackUser[]> => {

  return customFetch<SlackUser[]>(getListSlackUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSlackUsersQueryKey = () => {
    return [
    `/api/slack/users`
    ] as const;
    }


export const getListSlackUsersQueryOptions = <TData = Awaited<ReturnType<typeof listSlackUsers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSlackUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSlackUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSlackUsers>>> = ({ signal }) => listSlackUsers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSlackUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSlackUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listSlackUsers>>>
export type ListSlackUsersQueryError = ErrorType<unknown>


/**
 * @summary List Slack workspace members
 */

export function useListSlackUsers<TData = Awaited<ReturnType<typeof listSlackUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSlackUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSlackUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListSlackAlertConfigsUrl = () => {




  return `/api/slack/alert-configs`
}

/**
 * @summary Per-puller Slack alert configuration
 */
export const listSlackAlertConfigs = async ( options?: RequestInit): Promise<SlackAlertConfig[]> => {

  return customFetch<SlackAlertConfig[]>(getListSlackAlertConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSlackAlertConfigsQueryKey = () => {
    return [
    `/api/slack/alert-configs`
    ] as const;
    }


export const getListSlackAlertConfigsQueryOptions = <TData = Awaited<ReturnType<typeof listSlackAlertConfigs>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSlackAlertConfigs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSlackAlertConfigsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSlackAlertConfigs>>> = ({ signal }) => listSlackAlertConfigs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSlackAlertConfigs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSlackAlertConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof listSlackAlertConfigs>>>
export type ListSlackAlertConfigsQueryError = ErrorType<unknown>


/**
 * @summary Per-puller Slack alert configuration
 */

export function useListSlackAlertConfigs<TData = Awaited<ReturnType<typeof listSlackAlertConfigs>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSlackAlertConfigs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSlackAlertConfigsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateSlackAlertConfigUrl = (pullerId: number,) => {




  return `/api/slack/alert-configs/${pullerId}`
}

/**
 * @summary Upsert a puller's Slack alert config
 */
export const updateSlackAlertConfig = async (pullerId: number,
    slackAlertConfigUpdate: SlackAlertConfigUpdate, options?: RequestInit): Promise<SlackAlertConfig> => {

  return customFetch<SlackAlertConfig>(getUpdateSlackAlertConfigUrl(pullerId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      slackAlertConfigUpdate,)
  }
);}




export const getUpdateSlackAlertConfigMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSlackAlertConfig>>, TError,{pullerId: number;data: BodyType<SlackAlertConfigUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSlackAlertConfig>>, TError,{pullerId: number;data: BodyType<SlackAlertConfigUpdate>}, TContext> => {

const mutationKey = ['updateSlackAlertConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSlackAlertConfig>>, {pullerId: number;data: BodyType<SlackAlertConfigUpdate>}> = (props) => {
          const {pullerId,data} = props ?? {};

          return  updateSlackAlertConfig(pullerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSlackAlertConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateSlackAlertConfig>>>
    export type UpdateSlackAlertConfigMutationBody = BodyType<SlackAlertConfigUpdate>
    export type UpdateSlackAlertConfigMutationError = ErrorType<unknown>

    /**
 * @summary Upsert a puller's Slack alert config
 */
export const useUpdateSlackAlertConfig = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSlackAlertConfig>>, TError,{pullerId: number;data: BodyType<SlackAlertConfigUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSlackAlertConfig>>,
        TError,
        {pullerId: number;data: BodyType<SlackAlertConfigUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSlackAlertConfigMutationOptions(options));
    }

export const getAutoMapSlackUsersUrl = () => {




  return `/api/slack/auto-map`
}

/**
 * @summary Suggest Slack users for unmapped pullers by name match
 */
export const autoMapSlackUsers = async ( options?: RequestInit): Promise<SlackAutoMapSuggestion[]> => {

  return customFetch<SlackAutoMapSuggestion[]>(getAutoMapSlackUsersUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAutoMapSlackUsersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof autoMapSlackUsers>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof autoMapSlackUsers>>, TError,void, TContext> => {

const mutationKey = ['autoMapSlackUsers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof autoMapSlackUsers>>, void> = () => {


          return  autoMapSlackUsers(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AutoMapSlackUsersMutationResult = NonNullable<Awaited<ReturnType<typeof autoMapSlackUsers>>>

    export type AutoMapSlackUsersMutationError = ErrorType<unknown>

    /**
 * @summary Suggest Slack users for unmapped pullers by name match
 */
export const useAutoMapSlackUsers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof autoMapSlackUsers>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof autoMapSlackUsers>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAutoMapSlackUsersMutationOptions(options));
    }

export const getSaveSlackMappingsUrl = () => {




  return `/api/slack/save-mappings`
}

/**
 * @summary Save confirmed puller to Slack user mappings
 */
export const saveSlackMappings = async (saveSlackMappingsRequest: SaveSlackMappingsRequest, options?: RequestInit): Promise<SaveSlackMappingsResult> => {

  return customFetch<SaveSlackMappingsResult>(getSaveSlackMappingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveSlackMappingsRequest,)
  }
);}




export const getSaveSlackMappingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSlackMappings>>, TError,{data: BodyType<SaveSlackMappingsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveSlackMappings>>, TError,{data: BodyType<SaveSlackMappingsRequest>}, TContext> => {

const mutationKey = ['saveSlackMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveSlackMappings>>, {data: BodyType<SaveSlackMappingsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  saveSlackMappings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveSlackMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof saveSlackMappings>>>
    export type SaveSlackMappingsMutationBody = BodyType<SaveSlackMappingsRequest>
    export type SaveSlackMappingsMutationError = ErrorType<unknown>

    /**
 * @summary Save confirmed puller to Slack user mappings
 */
export const useSaveSlackMappings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSlackMappings>>, TError,{data: BodyType<SaveSlackMappingsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveSlackMappings>>,
        TError,
        {data: BodyType<SaveSlackMappingsRequest>},
        TContext
      > => {
      return useMutation(getSaveSlackMappingsMutationOptions(options));
    }

export const getTestSlackAlertUrl = (pullerId: number,) => {




  return `/api/slack/test-alert/${pullerId}`
}

/**
 * @summary Fire a puller's daily summary alert immediately
 */
export const testSlackAlert = async (pullerId: number, options?: RequestInit): Promise<TestSlackAlertResult> => {

  return customFetch<TestSlackAlertResult>(getTestSlackAlertUrl(pullerId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTestSlackAlertMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testSlackAlert>>, TError,{pullerId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testSlackAlert>>, TError,{pullerId: number}, TContext> => {

const mutationKey = ['testSlackAlert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testSlackAlert>>, {pullerId: number}> = (props) => {
          const {pullerId} = props ?? {};

          return  testSlackAlert(pullerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestSlackAlertMutationResult = NonNullable<Awaited<ReturnType<typeof testSlackAlert>>>

    export type TestSlackAlertMutationError = ErrorType<unknown>

    /**
 * @summary Fire a puller's daily summary alert immediately
 */
export const useTestSlackAlert = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testSlackAlert>>, TError,{pullerId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testSlackAlert>>,
        TError,
        {pullerId: number},
        TContext
      > => {
      return useMutation(getTestSlackAlertMutationOptions(options));
    }

export const getListHoldAlertConfigsUrl = () => {




  return `/api/slack/hold-alert-configs`
}

/**
 * @summary Global hold_set / hold_released Slack alert configs
 */
export const listHoldAlertConfigs = async ( options?: RequestInit): Promise<HoldAlertConfig[]> => {

  return customFetch<HoldAlertConfig[]>(getListHoldAlertConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHoldAlertConfigsQueryKey = () => {
    return [
    `/api/slack/hold-alert-configs`
    ] as const;
    }


export const getListHoldAlertConfigsQueryOptions = <TData = Awaited<ReturnType<typeof listHoldAlertConfigs>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHoldAlertConfigs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHoldAlertConfigsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHoldAlertConfigs>>> = ({ signal }) => listHoldAlertConfigs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHoldAlertConfigs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHoldAlertConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof listHoldAlertConfigs>>>
export type ListHoldAlertConfigsQueryError = ErrorType<unknown>


/**
 * @summary Global hold_set / hold_released Slack alert configs
 */

export function useListHoldAlertConfigs<TData = Awaited<ReturnType<typeof listHoldAlertConfigs>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHoldAlertConfigs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHoldAlertConfigsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateHoldAlertConfigUrl = (alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold',) => {




  return `/api/slack/hold-alert-configs/${alertType}`
}

/**
 * @summary Upsert a global hold alert config
 */
export const updateHoldAlertConfig = async (alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold',
    holdAlertConfigUpdate: HoldAlertConfigUpdate, options?: RequestInit): Promise<HoldAlertConfig> => {

  return customFetch<HoldAlertConfig>(getUpdateHoldAlertConfigUrl(alertType),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      holdAlertConfigUpdate,)
  }
);}




export const getUpdateHoldAlertConfigMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHoldAlertConfig>>, TError,{alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold';data: BodyType<HoldAlertConfigUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHoldAlertConfig>>, TError,{alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold';data: BodyType<HoldAlertConfigUpdate>}, TContext> => {

const mutationKey = ['updateHoldAlertConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHoldAlertConfig>>, {alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold';data: BodyType<HoldAlertConfigUpdate>}> = (props) => {
          const {alertType,data} = props ?? {};

          return  updateHoldAlertConfig(alertType,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHoldAlertConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateHoldAlertConfig>>>
    export type UpdateHoldAlertConfigMutationBody = BodyType<HoldAlertConfigUpdate>
    export type UpdateHoldAlertConfigMutationError = ErrorType<unknown>

    /**
 * @summary Upsert a global hold alert config
 */
export const useUpdateHoldAlertConfig = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHoldAlertConfig>>, TError,{alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold';data: BodyType<HoldAlertConfigUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHoldAlertConfig>>,
        TError,
        {alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold';data: BodyType<HoldAlertConfigUpdate>},
        TContext
      > => {
      return useMutation(getUpdateHoldAlertConfigMutationOptions(options));
    }

export const getTestHoldAlertUrl = (alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold',) => {




  return `/api/slack/hold-alert-configs/${alertType}/test`
}

/**
 * @summary Fire a sample hold alert to its configured destination
 */
export const testHoldAlert = async (alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold', options?: RequestInit): Promise<TestSlackAlertResult> => {

  return customFetch<TestSlackAlertResult>(getTestHoldAlertUrl(alertType),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTestHoldAlertMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testHoldAlert>>, TError,{alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold'}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testHoldAlert>>, TError,{alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold'}, TContext> => {

const mutationKey = ['testHoldAlert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testHoldAlert>>, {alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold'}> = (props) => {
          const {alertType} = props ?? {};

          return  testHoldAlert(alertType,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestHoldAlertMutationResult = NonNullable<Awaited<ReturnType<typeof testHoldAlert>>>

    export type TestHoldAlertMutationError = ErrorType<unknown>

    /**
 * @summary Fire a sample hold alert to its configured destination
 */
export const useTestHoldAlert = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testHoldAlert>>, TError,{alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold'}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testHoldAlert>>,
        TError,
        {alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold'},
        TContext
      > => {
      return useMutation(getTestHoldAlertMutationOptions(options));
    }

export const getGetEventAlertConfigUrl = () => {




  return `/api/slack/event-alert-config`
}

/**
 * @summary Global event-active Slack alert config
 */
export const getEventAlertConfig = async ( options?: RequestInit): Promise<EventAlertConfig> => {

  return customFetch<EventAlertConfig>(getGetEventAlertConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetEventAlertConfigQueryKey = () => {
    return [
    `/api/slack/event-alert-config`
    ] as const;
    }


export const getGetEventAlertConfigQueryOptions = <TData = Awaited<ReturnType<typeof getEventAlertConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventAlertConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventAlertConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventAlertConfig>>> = ({ signal }) => getEventAlertConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventAlertConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventAlertConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getEventAlertConfig>>>
export type GetEventAlertConfigQueryError = ErrorType<unknown>


/**
 * @summary Global event-active Slack alert config
 */

export function useGetEventAlertConfig<TData = Awaited<ReturnType<typeof getEventAlertConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventAlertConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventAlertConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getUpdateEventAlertConfigUrl = () => {




  return `/api/slack/event-alert-config`
}

/**
 * @summary Upsert the global event-active Slack alert config
 */
export const updateEventAlertConfig = async (
    eventAlertConfigUpdate: EventAlertConfigUpdate, options?: RequestInit): Promise<EventAlertConfig> => {

  return customFetch<EventAlertConfig>(getUpdateEventAlertConfigUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      eventAlertConfigUpdate,)
  }
);}




export const getUpdateEventAlertConfigMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEventAlertConfig>>, TError,{data: BodyType<EventAlertConfigUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEventAlertConfig>>, TError,{data: BodyType<EventAlertConfigUpdate>}, TContext> => {

const mutationKey = ['updateEventAlertConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEventAlertConfig>>, {data: BodyType<EventAlertConfigUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateEventAlertConfig(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEventAlertConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateEventAlertConfig>>>
    export type UpdateEventAlertConfigMutationBody = BodyType<EventAlertConfigUpdate>
    export type UpdateEventAlertConfigMutationError = ErrorType<unknown>

    /**
 * @summary Upsert the global event-active Slack alert config
 */
export const useUpdateEventAlertConfig = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEventAlertConfig>>, TError,{data: BodyType<EventAlertConfigUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEventAlertConfig>>,
        TError,
        {data: BodyType<EventAlertConfigUpdate>},
        TContext
      > => {
      return useMutation(getUpdateEventAlertConfigMutationOptions(options));
    }

export const getTestEventAlertUrl = () => {




  return `/api/slack/event-alert-config/test`
}

/**
 * @summary Fire a sample event-active alert to the configured channel
 */
export const testEventAlert = async ( options?: RequestInit): Promise<TestSlackAlertResult> => {

  return customFetch<TestSlackAlertResult>(getTestEventAlertUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTestEventAlertMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testEventAlert>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testEventAlert>>, TError,void, TContext> => {

const mutationKey = ['testEventAlert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testEventAlert>>, void> = () => {


          return  testEventAlert(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestEventAlertMutationResult = NonNullable<Awaited<ReturnType<typeof testEventAlert>>>

    export type TestEventAlertMutationError = ErrorType<unknown>

    /**
 * @summary Fire a sample event-active alert to the configured channel
 */
export const useTestEventAlert = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testEventAlert>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testEventAlert>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTestEventAlertMutationOptions(options));
    }

export const getGetNotificationPrefsUrl = () => {




  return `/api/me/notification-prefs`
}

/**
 * @summary Current puller's owner-notify subscription state
 */
export const getNotificationPrefs = async ( options?: RequestInit): Promise<NotificationPref[]> => {

  return customFetch<NotificationPref[]>(getGetNotificationPrefsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNotificationPrefsQueryKey = () => {
    return [
    `/api/me/notification-prefs`
    ] as const;
    }


export const getGetNotificationPrefsQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationPrefs>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationPrefs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationPrefsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationPrefs>>> = ({ signal }) => getNotificationPrefs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationPrefs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationPrefsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationPrefs>>>
export type GetNotificationPrefsQueryError = ErrorType<unknown>


/**
 * @summary Current puller's owner-notify subscription state
 */

export function useGetNotificationPrefs<TData = Awaited<ReturnType<typeof getNotificationPrefs>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationPrefs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNotificationPrefsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateNotificationPrefUrl = (alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold',) => {




  return `/api/me/notification-prefs/${alertType}`
}

/**
 * @summary Opt in/out of an owner-notify alert type
 */
export const updateNotificationPref = async (alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold',
    notificationPrefUpdate: NotificationPrefUpdate, options?: RequestInit): Promise<NotificationPref> => {

  return customFetch<NotificationPref>(getUpdateNotificationPrefUrl(alertType),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      notificationPrefUpdate,)
  }
);}




export const getUpdateNotificationPrefMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationPref>>, TError,{alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold';data: BodyType<NotificationPrefUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationPref>>, TError,{alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold';data: BodyType<NotificationPrefUpdate>}, TContext> => {

const mutationKey = ['updateNotificationPref'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationPref>>, {alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold';data: BodyType<NotificationPrefUpdate>}> = (props) => {
          const {alertType,data} = props ?? {};

          return  updateNotificationPref(alertType,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationPrefMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationPref>>>
    export type UpdateNotificationPrefMutationBody = BodyType<NotificationPrefUpdate>
    export type UpdateNotificationPrefMutationError = ErrorType<unknown>

    /**
 * @summary Opt in/out of an owner-notify alert type
 */
export const useUpdateNotificationPref = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationPref>>, TError,{alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold';data: BodyType<NotificationPrefUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationPref>>,
        TError,
        {alertType: 'hold_set' | 'hold_released' | 'sale_cancelled' | 'fve_sold';data: BodyType<NotificationPrefUpdate>},
        TContext
      > => {
      return useMutation(getUpdateNotificationPrefMutationOptions(options));
    }

